var _radialGradient, _radialGradient2, _radialGradient3, _radialGradient4, _radialGradient5, _radialGradient6, _radialGradient7, _radialGradient8, _radialGradient9, _radialGradient10, _radialGradient11, _radialGradient12, _radialGradient13, _radialGradient14, _radialGradient15, _radialGradient16, _radialGradient17, _radialGradient18, _radialGradient19, _radialGradient20, _radialGradient21, _radialGradient22, _radialGradient23, _radialGradient24, _radialGradient25, _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStartupBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "startup_bg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1864 1717.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 1791.52,
    cy: 3.04,
    fx: 1791.52,
    fy: 3.04,
    r: 1,
    gradientTransform: "rotate(89.95 531396.222 -528911.653) scale(592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#232b8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1f2782"
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 1793.78,
    cy: -5.31,
    fx: 1793.78,
    fy: -5.31,
    r: 1,
    gradientTransform: "rotate(-72.44 337335.904 455867.424) scale(373.43)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#323ff1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b2273"
  }))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 1788.14,
    cy: -2.36,
    fx: 1788.14,
    fy: -2.36,
    r: 1,
    gradientTransform: "translate(-661513.12 1585.16) scale(370.58)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1bbaff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#282f93"
  }))), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 1786.52,
    cy: -3.16,
    fx: 1786.52,
    fy: -3.16,
    r: 1,
    gradientTransform: "translate(-495397.04 1585.19) scale(277.93)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#99e7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1d4e98"
  }))), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 1783.27,
    cy: -4.72,
    fx: 1783.27,
    fy: -4.72,
    r: 1,
    gradientTransform: "translate(-329290.82 1585.21) scale(185.29)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3a8eb1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2b48bd"
  }))), _radialGradient6 || (_radialGradient6 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: 1780.03,
    cy: -6.3,
    fx: 1780.03,
    fy: -6.3,
    r: 1,
    gradientTransform: "translate(-246237.28 1590.23) scale(138.97)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#73d5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6587cd"
  }))), _radialGradient7 || (_radialGradient7 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cx: 1773.55,
    cy: -9.46,
    fx: 1773.55,
    fy: -9.46,
    r: 1,
    gradientTransform: "translate(-163174.59 1585.2) scale(92.64)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3a42b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#86aefc"
  }))), _radialGradient8 || (_radialGradient8 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "h",
    cx: 1754.1,
    cy: -18.92,
    fx: 1754.1,
    fy: -18.92,
    r: 1,
    gradientTransform: "translate(-80121.12 1585.2) scale(46.32)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#65a7f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9bf3ff"
  }))), _radialGradient9 || (_radialGradient9 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "i",
    cx: 1702.08,
    cy: -102.81,
    fx: 1702.08,
    fy: -102.81,
    r: 1,
    gradientTransform: "rotate(-21.5 19008.107 63472.421) scale(14.91 14.35)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dcf8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3fb0d3",
    stopOpacity: 0.3
  }))), _radialGradient10 || (_radialGradient10 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "m",
    cx: 1673.58,
    cy: -58.05,
    fx: 1673.58,
    fy: -58.05,
    r: 1,
    gradientTransform: "translate(-23862.49 2156.9) scale(15.09)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#4c7e9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0c1b27"
  }))), _radialGradient11 || (_radialGradient11 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "n",
    cx: 1620.9,
    cy: -83.66,
    fx: 1620.9,
    fy: -83.66,
    r: 1,
    gradientTransform: "translate(-15572.55 2154.19) scale(10.47)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4d7898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f1b27"
  }))), _radialGradient12 || (_radialGradient12 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "o",
    cx: 1651.8,
    cy: -66.36,
    fx: 1651.8,
    fy: -66.36,
    r: 1,
    gradientTransform: "matrix(12.76 0 0 13.2 -19680.47 2155.01)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#326285"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f1b27"
  }))), _radialGradient13 || (_radialGradient13 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "p",
    cx: 1586.07,
    cy: -100.6,
    fx: 1586.07,
    fy: -100.6,
    r: 1,
    gradientTransform: "matrix(8.71 0 0 8.71 -12838.65 2042.41)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#4c7e9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0c1b27"
  }))), _radialGradient14 || (_radialGradient14 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "q",
    cx: 1494.7,
    cy: -145.02,
    fx: 1494.7,
    fy: -145.02,
    r: 1,
    gradientTransform: "matrix(6.04 0 0 6.04 -8051.88 2040.85)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4d7898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f1b27"
  }))), _radialGradient15 || (_radialGradient15 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "r",
    cx: 1548.22,
    cy: -114.98,
    fx: 1548.22,
    fy: -114.98,
    r: 1,
    gradientTransform: "matrix(7.36 0 0 7.62 -10420.82 2041.3)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#326285"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f1b27"
  }))), _radialGradient16 || (_radialGradient16 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "s",
    cx: 1586.07,
    cy: -100.6,
    fx: 1586.07,
    fy: -100.6,
    r: 1,
    gradientTransform: "matrix(8.71 0 0 8.71 -13717.65 2225.41)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#4c7e9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0c1b27"
  }))), _radialGradient17 || (_radialGradient17 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "t",
    cx: 1494.7,
    cy: -145.02,
    fx: 1494.7,
    fy: -145.02,
    r: 1,
    gradientTransform: "matrix(6.04 0 0 6.04 -8930.88 2223.85)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4d7898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f1b27"
  }))), _radialGradient18 || (_radialGradient18 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "u",
    cx: 1548.22,
    cy: -114.98,
    fx: 1548.22,
    fy: -114.98,
    r: 1,
    gradientTransform: "matrix(7.36 0 0 7.62 -11299.82 2224.3)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#326285"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f1b27"
  }))), _radialGradient19 || (_radialGradient19 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "w",
    cx: 1729.64,
    cy: -30.96,
    fx: 1729.64,
    fy: -30.96,
    r: 1,
    gradientTransform: "matrix(28.44 0 0 28.29 -49122.29 1730.31)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#465bef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4458ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#3d4edc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#313ec5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#2227a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#141489"
  }))), _radialGradient20 || (_radialGradient20 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "x",
    cx: 1681.29,
    cy: -54.58,
    fx: 1681.29,
    fy: -54.58,
    r: 1,
    gradientTransform: "matrix(16.13 0 0 16.05 -27046.14 1724.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#46ccef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#41beec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#3399e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2066db"
  }))), _radialGradient21 || (_radialGradient21 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "y",
    cx: 1786.43,
    cy: -4.96,
    fx: 1786.43,
    fy: -4.96,
    r: 1,
    gradientTransform: "matrix(274.16 0 0 176.87 -489031.81 1789.97)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#46ccef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#41beec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#3399e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2066db"
  }))), _radialGradient22 || (_radialGradient22 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "z",
    cx: 1775.82,
    cy: -10.62,
    fx: 1775.82,
    fy: -10.62,
    r: 1,
    gradientTransform: "matrix(104.86 0 0 82.51 -185883.34 1757.54)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#46ccef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#41beec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#3399e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2066db"
  }))), _radialGradient23 || (_radialGradient23 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "A",
    cx: 1724.3,
    cy: -33.58,
    fx: 1724.3,
    fy: -33.58,
    r: 1,
    gradientTransform: "matrix(26.23 0 0 26.09 -45151.77 1727.23)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c2f7ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#b4eaed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#8fc9e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#5394e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2066db"
  }))), _radialGradient24 || (_radialGradient24 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "E",
    cx: 1702.08,
    cy: -102.81,
    fx: 1702.08,
    fy: -102.81,
    r: 1,
    gradientTransform: "rotate(-21.5 19836.26 63097.484) scale(14.91 14.35)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7ad2e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2b3289",
    stopOpacity: 0
  }))), _radialGradient25 || (_radialGradient25 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "F",
    cx: 1702.08,
    cy: -102.81,
    fx: 1702.08,
    fy: -102.81,
    r: 1,
    gradientTransform: "rotate(-21.5 20055.572 63875.436) scale(14.91 14.35)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7ad2e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2b3289",
    stopOpacity: 0
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 928.05,
    y1: -6.1,
    x2: 939.32,
    y2: -76.58,
    gradientTransform: "translate(0 876)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#add2f1",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#005cff",
    stopOpacity: 0.3
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 851.05,
    y1: 380.9,
    x2: 862.32,
    y2: 310.41,
    gradientTransform: "translate(0 876)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#add2f1",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#005cff",
    stopOpacity: 0.3
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 511.05,
    y1: 476.9,
    x2: 522.32,
    y2: 406.41,
    gradientTransform: "translate(0 876)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#add2f1",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#005cff",
    stopOpacity: 0.3
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: 58.48,
    y1: 9.85,
    x2: 51.03,
    y2: -21.39,
    gradientTransform: "translate(0 876)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#135195"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    x1: 1363.21,
    y1: 452.85,
    x2: 1396.6,
    y2: 396.71,
    gradientTransform: "translate(0 876)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#080b32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#474a80"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "v"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M38 843h49v49H38z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "B"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "m33.7 858.8 34.5-8.2 7.5 31.1-34.5 8.3-7.5-31.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "startup_nebula"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "startup_nebula_ring_9",
    cx: 1130.5,
    cy: 733.5,
    r: 733.5,
    style: {
      fill: "url(#a)",
      isolation: "isolate",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "startup_nebula_ring_8",
    cx: 1130.3,
    cy: 709.2,
    r: 420.3,
    style: {
      fill: "url(#b)",
      isolation: "isolate",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "startup_nebula_ring_7",
    cx: 1130.3,
    cy: 709.2,
    r: 336.3,
    style: {
      fill: "url(#c)",
      fillOpacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "startup_nebula_ring_6",
    cx: 1130.3,
    cy: 709.2,
    r: 252.2,
    style: {
      fill: "url(#d)",
      fillOpacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "startup_nebula_ring_5",
    cx: 1130.3,
    cy: 709.2,
    r: 168.1,
    style: {
      fill: "url(#e)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "startup_nebula_ring_4",
    cx: 1130.3,
    cy: 714.2,
    r: 126.1,
    style: {
      fill: "url(#f)",
      fillOpacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "startup_nebula_ring_3",
    cx: 1130.3,
    cy: 709.2,
    r: 84.1,
    style: {
      fill: "url(#g)",
      fillOpacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "startup_nebula_ring_2",
    cx: 1130.3,
    cy: 709.2,
    r: 42,
    style: {
      fill: "url(#h)",
      fillOpacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "startup_nebula_ring_1",
    cx: 1130.3,
    cy: 709.2,
    r: 21,
    style: {
      fill: "url(#i)",
      fillOpacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "startup_comets"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "startup_comet_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m865.2 854.3 137-39.5-131 55.8-6-16.3Z",
    style: {
      fill: "url(#j)",
      isolation: "isolate",
      opacity: 0.22
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M868.5 870.6c4.7 0 8.5-3.8 8.5-8.5s-3.8-8.5-8.5-8.5-8.5 3.8-8.5 8.5 3.8 8.5 8.5 8.5Z",
    style: {
      fill: "#2c3276"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "startup_comet_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m788.2 1241.3 137-39.5-131 55.8-6-16.3Z",
    style: {
      fill: "url(#k)",
      isolation: "isolate",
      opacity: 0.22
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.5 1257.6c4.7 0 8.5-3.8 8.5-8.5s-3.8-8.5-8.5-8.5-8.5 3.8-8.5 8.5 3.8 8.5 8.5 8.5Z",
    style: {
      fill: "#2c3276"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "startup_comet_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m448.2 1337.3 137-39.5-131 55.8-6-16.3Z",
    style: {
      fill: "url(#l)",
      isolation: "isolate",
      opacity: 0.22
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.5 1353.6c4.7 0 8.5-3.8 8.5-8.5s-3.8-8.5-8.5-8.5-8.5 3.8-8.5 8.5 3.8 8.5 8.5 8.5Z",
    style: {
      fill: "#2c3276"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "startup_plamets"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "startup_plamet_5",
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1403 1288v.9c-.1 1.1-.3 2.2-.6 3.2-.6 1.8-1.6 3.5-3 4.9-1.2 1.2-2.6 2.2-4.1 2.9-1 .4-2 .7-3 .9-.8.1-1.5.2-2.3.2-2.8 0-5.5-.9-7.7-2.5-1.6-1.2-2.9-2.7-3.8-4.5-.2-.3-.3-.6-.5-1-.7-1.6-1-3.2-1-4.9v-.7c0-.2 0-.4.1-.6v-.3c0-.1 0-.2.1-.3s0-.2 0-.3c0-.2.1-.4.1-.5s0-.2.1-.3c.1-.4.2-.8.3-1.1l.1-.2q0-.1.1-.2c0-.1.1-.2.1-.3s.1-.2.1-.3c.3-.6.6-1.1.9-1.7 0-.1.1-.1.1-.2s.1-.2.2-.2c.3-.4.6-.8.9-1.1 1.1-1.2 2.4-2.3 3.9-3 1.2-.6 2.4-1 3.7-1.2 2.7-.5 5.4-.1 7.9 1.1.3.1.5.2.8.4h.1c1.6.9 2.9 2.1 4 3.6.3.5.6.9.9 1.4.4.6.7 1.3.9 2v.2c.3.8.4 1.7.5 2.5 0 .2 0 .5.1.7v.5Z",
    style: {
      fill: "url(#m)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1403 1288v.9c0 .2-.1.3-.2.4-.2.2-.4.3-.7.3-.4.1-.7.1-1.1.2-.4 0-.9.2-1.3.3-.8.3-1.6.6-2.3 1-.8.4-1.6.8-2.5 1-.4.2-.9.2-1.4.4-.2.1-.4.1-.6.2-.3.1-.6.2-.9.2-.4.1-.8.2-1.1.3-.4.1-.9.2-1.3.3-.3.1-.7.1-1.1.1h-1.9c-.3.1-.7.1-1 0s-.7-.1-1-.2-.7-.1-1-.1h-1.4c-.3 0-.6-.1-.9-.3-.3-.1-.7-.2-1-.3-.3-.1-.6-.1-1-.1h-.4c-.1 0-.2 0-.2.1 0 0-.1 0-.1.1l-.1.1c-.1 0-.1.1-.2.1h-.3c-.7-1.6-1-3.2-1-4.9v-.7c0-.2 0-.4.1-.6v-.3c0-.1 0-.2.1-.3s0-.2 0-.3c0-.2.1-.4.1-.5s0-.2.1-.3c.1-.4.2-.8.3-1.1l.1-.2q0-.1.1-.2c0-.1.1-.2.1-.3s.1-.2.1-.3c.3-.6.6-1.1.9-1.7 0-.1.1-.1.1-.2s.1-.2.2-.2c.3-.4.6-.8.9-1.1-.1.2-.2.5-.2.8 0 .1 0 .2.1.2.1-.1.2-.3.3-.5.1-.2.3-.4.4-.6.2-.2.3-.3.4-.5.1-.1.2-.2.3-.2 0 .1-.1.2-.1.3s-.1.2-.2.3v.1l.1-.1c.1 0 .1-.1.2-.2.1 0 .2-.1.3-.2.1-.1.3-.2.4-.3.4-.3.8-.6 1.2-.8.4-.2.9-.5 1.3-.7.2-.1.5-.2.7-.3.2-.1.4-.1.6-.2.2 0 .3 0 .5-.1h1.1c.1.1-.2.1-.3.1-.2.1-.3.3-.4.4s-.2.2-.4.3c-.1.1-.2.2-.3.4v.2c0 .1.1 0 .2 0 .2 0 .3-.1.5-.1.2-.1.4-.1.7-.2.2-.1.4-.1.6-.2.2 0 .4-.1.6-.1h.6c.2 0 0 .2 0 .2-.3.2-.6.3-.9.4-.4.1-.8.2-1.1.3-.2.1-.5.2-.8.3l-.4.2-.6.3c-.3.1-.6.3-.8.5-.2.2-.5.4-.7.5-.2.2-.4.3-.6.6-.2.2-.3.4-.4.6s-.2.5-.2.8c0 .1 0 .2.1.3 0 .1.1.2.2.2.2.1.4.2.7.2h.5c.2-.1.5-.1.7-.2h.8c.3 0 .6.1.9.2s.5.3.8.5.7.5 1 .8l.5.5c.1.1.3.2.4.3.3.2.7.4 1.1.5.3.1.6.1.9 0 .2-.1.4-.2.7-.2h.4c.2 0 .4.1.7.1h.3c.1 0 .2 0 .3.1.1 0 .2.1.1.2s-.3.1-.5.1h-.7c-.1 0-.3.1-.4.2 0 .1.3.1.4.1.2 0 .5-.1.7-.1.3 0 .6 0 .8.1.3 0 .5.1.8.1h.3c.2 0 .4-.1.6-.2l.9-.3h.8c.1 0 .3.1.4.1h.4c.4 0 .8-.1 1.1-.2.4-.2.8-.4 1.2-.5.3-.1.5-.1.8-.2h.3q.1 0 .1-.1c0-.1.1-.1.1-.2s0-.1.1-.2c0-.1 0-.2.1-.2 0-.1.1-.3.2-.3v.2c.3.8.4 1.7.5 2.5-.1 0-.2-.1-.3-.1s-.3-.1-.4-.1c-.2 0-.3-.1-.4-.1-.3 0-.6 0-.9.1-.1.1-.3.1-.4.2s-.2.1-.4.2c-.1.1-.3.1-.4.2-.2.1-.4.2-.6.2-.3.1-.6.2-1 .4-.3.1-.6.1-.9.2h-.8c-.1 0-.2.1-.3.1s-.2 0-.3.1h-.4c-.2 0-.5.1-.7.1h-.5c-.2 0-.3 0-.5.1-.2 0-.3.1-.5.1l-.1.1c0 .1.1.1.1.1.1 0 .2.1.3 0h.7c.4 0 .9 0 1.3.1.3.1.6.1.8 0 .4-.1.7-.2 1.1-.2.7-.1 1.3-.2 2-.4.3-.1.6-.2.9-.2l.4-.1c.2 0 .4 0 .6-.1.3 0 .6-.1.9-.2.2 0 .4 0 .5-.1.2.1.2.4.2.6Z",
    style: {
      fill: "#070d18"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1400.4 1295.8c-2 2.6-4.8 4.4-8.1 5-.2-.2-.4-.4-.6-.5-.2-.2-.4-.4-.7-.6-.4-.3-.8-.5-1.3-.8s-1-.5-1.5-.7c-.3-.1-.6-.2-.8-.3-.4-.1-.7-.1-1.1-.1-1.1-.2-2.3 0-3.4.3-.2.1-.4.2-.7.3-1.6-1.2-3-2.7-3.9-4.5.1 0 .2-.1.4-.1h.3c.2 0 .3.1.5.1.4.2.9.3 1.3.2.1 0 .2 0 .3-.1.1 0 .2-.1.3-.1h.5c.1 0 .2 0 .4.1h.3c.1 0 .2.1.3.1h.4c.2 0 .5-.1.8-.2.2-.1.4-.1.6-.1.5 0 1 .1 1.4.3.3.1.5.1.8.1h.8c.4 0 .9 0 1.3-.1.2 0 .3 0 .5-.1.3-.1.6-.1 1-.2.8-.2 1.6-.3 2.3-.6.3-.1.7-.2 1-.3.1 0 .3-.1.4-.1h.5v.3c0 .1-.2.2-.3.2-.1.1-.2.1-.4.2s-.5.2-.7.3c-.2 0-.3.1-.5.1s-.3.1-.5.2-.3.2-.4.2c-.2.1-.4.1-.6.2-.5.2-1 .5-1.6.6-.2 0-.4.1-.5.2-.1 0-.2.1-.2.2 0 .2.2.2.4.2.2.1.4.1.5.2.1 0 .2.1.3.2.2.1.3.2.5.2.4.1.8.2 1.2.2.6 0 1.2-.1 1.7-.1.2 0 .5.1.7.1.2.1.5.1.7.1.6.1 1.2.1 1.9 0 .4 0 .9-.1 1.3-.2.3 0 .6-.1.9-.2.1 0 .3-.1.4-.1s.2-.1.2-.1c.5-.1.6-.1.7-.2Z",
    style: {
      fill: "#070d18"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1402.3 1292.1c-.1.5-.3.9-.5 1.4-.2.1-.3.2-.4.3-.1.1-.2.2-.3.2s-.2.1-.2.1c-.1 0-.2.1-.2.1-.1.1-.3.2-.4.3l-.1.1c-.1 0-.1.1-.1.1l-.2.2c-.2.1-.3.2-.5.3-.1.1-.2.1-.4.1-.1 0-.3.1-.4.1s-.3.1-.4.1-.3.1-.4.1c-.2 0-.5 0-.7.1-.1 0-.2.1-.4.1-.1 0-.2.1-.4.1h-3.5c0-.1 0-.2.1-.2 0 0 0-.1.1-.1h1.1c.1 0 .3 0 .4.1.1 0 .3.1.4.1.4.2.9.2 1.3.2h.2s.2-.1.3-.1c.3 0 .5-.1.8-.2.1 0 .2-.1.3-.1.1-.1.2-.1.3-.2.1-.1.2-.1.3-.2l.3-.1c.2-.1.5-.2.7-.4.2-.1.4-.3.6-.4.2-.2.5-.4.7-.5s.4-.2.5-.3c.1-.1.2-.1.3-.2.1-.1.2-.3.2-.4l.3-.3c.1 0 .1-.1.2-.1l.1-.4Z",
    style: {
      fill: "#070d18"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1401.4 1281.8c-.3.3-.6.5-1 .6-.5.2-1 .2-1.5.2-.1 0-.2.1-.3.1h-.3c-.2 0-.4.1-.7.1s-.6.1-.9.1c-.3.1-.7.1-1 0 0-.1.4-.2.5-.2.2-.1.5-.2.8-.2.2 0 .3-.1.5-.1h.4c.1 0 .6-.1.5-.3 0-.1-.1-.1-.2-.2s-.2-.1-.3-.1c-.2 0-.3 0-.1-.2.1-.1.2-.3 0-.4-.2 0-.4 0-.5.1h-.3c-.1 0-.2.1-.3.1h-.3c-.1 0-.2 0-.4.1-.5 0-1 .3-1.4.2l-.6-.1c-.3 0-.6 0-.9.1-.3 0-.7.1-1.1.1-.2.1-.4.1-.7.1.1-.1.3-.1.4-.1.3-.1.6-.1.9-.2s.7-.1 1-.1h.6c.6-.1 1.2-.2 1.8-.4.5-.2 1-.7 1.4-1.1.2-.2.4-.4.6-.7.1-.2.1-.3.2-.5v-.5c1.3.8 2.4 2 3.2 3.5Z",
    style: {
      fill: "#070d18"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1378.6 1282.7c.1-.3.3-.6.4-.9 0-.1.1-.1.2-.2s.2-.3.4-.3 0 .3.2.3.4-.3.6-.4c.1-.1.2-.1.3-.1s.1.1.1.2c.1 0 .2-.1.2-.1.2-.2.3-.3.5-.4.1 0 .5-.3.6-.2s-.2.5-.3.6c-.2.3-.4.6-.4.9s0 .5.2.8c.1.2.3.4.6.5.1.1.2.1.3.2.1.1.3.1.5.2.4.1.8.2 1.1.3.4 0 .8 0 1.2-.1.2-.1.5-.1.7 0s.3.2.3.4c.1.1.3.2.5.3l.6.3c.1.1.2.2.4.2.1.1.2.1.3.2.1.1.2.2.2.3s.1.2.1.3-.1.2-.2.3l.6.3s.2.1.2.2-.4.1-.5.1h-2.3c-.3 0-.5 0-.8.1h-.1l-.1.1c.1.1.3.2.5.2.4.1.8.2 1.2.2.4.1.7.2 1 .3.2 0 .3.1.4.1h.6c.8.1 1.6-.1 2.4-.1.3 0 .6 0 .9-.1.3 0 .5-.1.8-.2.2 0 .3-.1.5-.1.1 0 .3-.1.5-.1.3-.1.6-.1.8-.1.3 0 .5.1.8 0 .4 0 .8-.2 1.1-.2.7-.1 1.4-.3 2.1-.6.3-.1.5-.2.8-.2q.1 0 .2-.1h.2c.1 0 .3-.1.4-.2.2-.1.4-.2.6-.4.2-.1.4-.1.6-.2.1 0 .2-.1.2-.1h.2c-.2.1-.3.2-.5.2-.2.1-.3.2-.5.3-.1.1-.2.2-.3.2-.2.2-.5.3-.7.4-.4.1-.9.3-1.3.4s-.9.2-1.3.3c-.9.2-1.9.4-2.9.5-.4 0-.8.1-1.1.2-.1 0-.3.1-.4.2-.2 0-.4.1-.5.2-.4.1-.7.2-1.1.4-.2.1-.5.1-.6.3.1.1.3.1.5.1h.4c.2 0 .3-.1.4-.2s.3-.1.4-.2.2-.1.3-.1h.2c.1 0 .1-.1.2 0 0 .1-.2.1-.3.2-.1 0-.2.1-.3.1q-.1.1 0 .2c.2.1.4.1.6 0 .6 0 1.1-.2 1.7-.1.3.1.6.2 1 .2.4.1.8.1 1.2 0 .4 0 .8-.2 1.2-.2.2 0 .4-.1.6-.1.3-.1.5-.1.8-.1.3-.1.7-.2 1-.2s.5-.1.8-.1h.3c.1 0 .2 0 .2.1.1 0 .2 0 .3.1-.6.4-1.4.4-2.1.6-.4.1-.9.3-1.3.4-.5.2-1.1.3-1.6.5s-1 .3-1.5.5c-.4.1-.8.3-1.2.4-.2.1-.4.2-.6.2-.2.1-.4.1-.6.2s-.3.1-.5.2-.4.2-.6.2c-.2.1-.5.1-.7.2s-.4.1-.5.2c-.3.1-.6.2-.9.2-.2.1-.4.1-.6.2-.2 0-.5.1-.7.1s-.4.1-.7.1h-.6c-.3 0-.6.1-.9.1h-.8c0-.1.2-.1.3-.1h.8c.2 0 .3 0 .5-.1.2 0 .5-.1.7-.1.1 0 .2-.1.4-.2.1 0 .2-.1.3-.1.2 0 .4-.1.6-.1h.3c.2 0 .3-.1.5-.2.3-.1.5-.2.8-.3.2-.1.3-.1.4-.3.2-.3-.3-.2-.4-.2l-1.2.3c-.2 0-.3 0-.5.1-.2 0-.4.1-.6.1s-.4 0-.6.1c-.3 0-.6 0-.9.1-.3 0-.6.1-1 .1-.2 0-.5 0-.7.1-.4 0-.7.1-1 .2-.2 0-.4.1-.6.1h-.6c-.3-.1-.7-.1-1-.2-.5-.1-.9-.4-1.3-.7-.3-.3-.8-.5-1.3-.6-.4 0-.7 0-1.1.1-.3.1-.6.1-.8.1-.3 0-.2-.3-.2-.5 0-.6 0-1.2.1-1.8 0-.2.2-2 .5-1.8 0 .1.1.3.1.4s.1.2.1.3c.1 0 .2-.4.2-.4.1-.3.1-.6.2-.8.1-.4.1-.7.1-1.1 0-.1 0-.3-.1-.4s-.1-.1-.2-.1c-.2 0-.3-.2-.3-.4 0-.3.1-.5.2-.8.1-.2.2-.5.3-.7-.4-.1-.3-.3-.3-.2Z",
    style: {
      fill: "#070d18"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1399.4 1297c-1.2 1.2-2.5 2.2-4.1 2.9-.2-.1-.5-.2-.8-.2-.2 0-.5 0-.6-.1s.2-.2.3-.2.3 0 .4-.2c.1-.3-1.1-.4-1.2-.5-.3-.1-.7-.1-1-.1-.2 0-.4 0-.6-.1s-.4-.1-.6-.2l-1.2-.3c-.1 0-.5 0-.5-.1.2-.1.4-.1.6-.2h.5c.9.2 1.8.3 2.8.2.1 0 .2 0 .3-.1h.3c.3 0 .6 0 .9-.1s.5-.1.8-.2c.1 0 .3 0 .4-.1h-1.2c-.3 0-.5 0-.8-.1-.2 0-.3 0-.5-.1.1-.1.3-.1.4-.1.2 0 .5-.1.8-.1.6-.1 1.2-.1 1.9-.1.3 0 .7-.1 1-.1s.5.1.8.1h.6c.1.2.2.1.3.1Z",
    style: {
      fill: "#070d18"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1383.6 1284.4c0 .2-.1.5 0 .7.1.1.1.2.2.2.3.2.6.2.9.2.2 0 .5-.1.7-.2s.3-.3.3-.5v-.3c0-.1-.1-.1-.1-.2l-.1-.1h-1.1c-.1 0-.2 0-.3.1-.2 0-.4 0-.5.1Z",
    style: {
      fill: "#223648"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1385.9 1285.2c.1-.1.2-.2.3-.2s.2.1.2.1v.1s0 .1-.1.1l-.1.1h-.1c0-.1-.1-.1-.2-.2Z",
    style: {
      fill: "#223648"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1385.1 1285.7c.1-.1.2-.1.4-.2.1 0 .1-.1.2-.1h.4c0 .1.1.1.1.2v.2c0 .1-.1.2-.1.3-.1.1-.3.2-.4.2-.2.1-.4.1-.5.1s-.2 0-.3-.1c-.1 0-.3 0-.4-.1-.1 0-.3-.1-.3-.3 0-.1.1-.2.2-.2.1-.1.2-.1.3-.1h.2c0 .1.1.1.2.1Z",
    style: {
      fill: "#223648"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1386.6 1285.4c-.1.1-.1.2-.2.3h.2q.1 0 .1-.1v-.1q0-.1-.1-.1Z",
    style: {
      fill: "#223648"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1388.1 1288.2c-.4-.1-.9-.1-1.3-.1-.5 0-1 .2-1.4.5-.2.1-.3.3-.3.5 0 .1 0 .2.1.2 0 .1.1.1.2.1.2.1.5.2.7.3.2.1.5.1.7.2h.7c.2 0 .5-.1.7-.2.2 0 .4-.1.5-.3.1-.1.1-.2.1-.3v-.4c0-.2-.1-.2-.2-.3 0-.1-.1-.1-.2-.2h-.3Z",
    style: {
      fill: "#223648"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1389.2 1288.2c0 .1.1.2.2.3.1-.1.2 0 .3 0h.2c.1 0 .2 0 .3-.2 0-.1-.2-.2-.3-.2-.3 0-.5 0-.7.1Z",
    style: {
      fill: "#223648"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1385.3 1290c.2 0 .3 0 .5.1.2 0 .3 0 .5.1.1 0 .2 0 .2.1.1.1 0 .1 0 .1l-.2.2c-.1.1-.3.1-.4.2-.3.1-.6.1-.9.1-.1 0-.2 0-.2-.1-.1 0-.1-.1-.2-.2 0-.1-.1-.1-.1-.2v-.2c0-.1.1-.2.2-.2s.1-.1.2-.1c.2.1.3.1.4.1q0 .1 0 0Z",
    style: {
      fill: "#223648"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1377.9 1289.4c0 .3-.1.5-.1.8v.2c0 .1.1.1.1.1.1.1.3.1.4 0 .2-.1.3-.2.4-.2l.2-.2c.1-.2.2-.3.2-.5v-.7c0-.2-.1-.4-.2-.6 0-.1-.1-.2-.2-.2-.1-.1-.2-.1-.3-.1-.2 0-.3.1-.5.2l-.2.2c-.1.1-.1.2-.1.3s0 .2-.1.3c.3.1.3.3.4.4Z",
    style: {
      fill: "#223648"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1378.6 1287.4c0-.1-.1-.3-.1-.4 0 0 0-.1.1-.1v-.1h.1c.1 0 .2.1.3.2v.3c-.1.1-.2.2-.4.1Z",
    style: {
      fill: "#223648"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1378.9 1286.3c0-.3-.1-.7.1-1 .1-.1.2-.3.3-.2.1 0 .2.1.2.2.1.1.1.2.2.3.1.1.1.2.1.3s0 .3-.1.4c0 .1-.1.2-.1.2q-.1.1-.2.1h-.2s-.1 0-.2-.1l-.1-.1v-.1Z",
    style: {
      fill: "#223648"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1378.7 1284.7c0 .1.1.2.1.3h.1c.1 0 .1-.1.1-.1v-.2c0-.1-.1-.1-.2-.2 0-.1-.1 0-.1.2Z",
    style: {
      fill: "#223648"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1390.7 1289.9c.1-.1.3-.2.4-.2s.2-.1.3-.1c.2-.1.5-.1.7-.1h.7c.3 0 .6-.1.8-.2.1 0 .3-.1.4-.1h.7c.6.1 1.2.2 1.8.4.1 0 .3.1.4.1.2.1.4.1.6.1s.1-.2 0-.3c-.1-.1-.3-.2-.5-.1h-.3c-.2 0-.4.1-.4.3v.3c0 .1-.2.3-.3.4-.1 0-.1.1-.2.1-.1.1-.2.1-.2.1-.1.1-.2.1-.4.2-.1 0-.2.1-.3.1-.2.1-.5.2-.7.3-.2.1-.4.1-.6.2-.1 0-.2.1-.3.1 0 0-.1 0-.2.1-.1 0-.2 0-.2.1-.3.1-.6.2-1 .2-.1 0-.2 0-.3-.1-.1-.1-.1-.2-.2-.4 0-.2-.1-.3-.3-.4-.2-.1-.3-.1-.5-.2q-.1-.1-.1-.2c0-.1-.1-.2 0-.2v-.2c0-.3.1-.3.2-.3Z",
    style: {
      fill: "#223648"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1397.4 1289.1c.1 0 .2-.1.3-.1h.4s0 .1-.1.2c0 0-.1.1-.2.1h-.4q.1-.1 0-.2Z",
    style: {
      fill: "#223648"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1387.3 1295.4c-.3 0-.7.1-.9.2l-.3.3c-.2.2.2.3.4.3.3 0 .7.1 1 .3.3.1.6.2.9.1.2-.1.4-.1.4-.3v-.3c0-.1-.1-.2-.2-.2-.2-.2-.4-.3-.6-.4-.3-.1-.5-.1-.7 0Z",
    style: {
      fill: "#223648"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1386.7 1295c-.1 0-.1.1-.2.1.1 0 .2.1.3.1h.3q.1 0 .2-.1v-.2l-.1-.1h-.3c0 .1-.1.1-.2.2Z",
    style: {
      fill: "#223648"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1385.1 1296.3h.5c.1 0 .3 0 .4.1h.1l.1.1c0 .1.1.1.1.2 0 .3-.4.3-.6.4h-.6c-.2 0-.4-.1-.6-.1-.1 0-.3-.1-.4-.1h-.1l-.1-.1s0-.1-.1-.1v-.1s0-.1.1-.1l.1-.1c.2-.1.5-.1.7-.1h.4c-.2 0-.1.1 0 0Z",
    style: {
      fill: "#223648"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1391.1 1281.7c-.1.1-.3.1-.4.1h-.2l-.4-.1h-1.7c-.2 0-.4-.1-.5-.1s-.1 0-.2-.1h-.3c-.2 0-.4 0-.5-.1q-.1 0-.2-.1v-.1h.2c.2.1.3.1.4.2.2.2.6 0 .8.1h.4c.1 0 .1.1.2.1h.3c.2 0 .4-.1.6-.2s.5-.2.7-.2.4 0 .6.1q.1 0 .2.1c.1 0 .1.1 0 .3Z",
    style: {
      fill: "#070d18"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1390.3 1277.7h.3-.3c0 .1-.1.1 0 0-.2.1-.4.1-.3 0h.3Z",
    style: {
      fill: "#070d18"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1396.5 1276.7c-.1.2-.3.4-.4.6s-.3.3-.5.4-.5.2-.7.3c-.3.1-.5.1-.8.1h-.6c-.2 0-.5-.1-.8-.1l-.6-.1c-.2 0-.4-.1-.6-.1h-.9 1.2c.2 0 .5-.1.8-.1h.8s.1 0 .1-.1.1-.1 0-.2c0 0-.4-.1-.4-.3h.1c.2 0 .3 0 .5-.1.1 0 .2 0 .3-.1.1 0 .2 0 .2-.1h1.1c.1 0 .2-.1.3-.2l.1-.1c0-.1.1-.1.1-.2.2.1.5.2.7.4q-.1 0 0 0Z",
    style: {
      fill: "#070d18"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1396.4 1277.4c-.2.2-.4.4-.6.5l-.6.3c-.2.1-.3.1-.5.2-.1 0-.2 0-.2.1h-.1c-.1.1 0 .1 0 .1h.5c.3 0 .6-.1.9-.1.2 0 .4-.1.5-.2.2-.1.4-.3.6-.5.1-.2.1-.3 0-.4-.1 0-.1-.1-.2-.1-.2 0-.4 0-.3.1Z",
    style: {
      fill: "#070d18"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1400.5 1280.3c-.3 0-.6-.1-.8-.2-.1 0-.5-.3-.2-.3 0-.1-.2-.2-.2-.2-.1-.1-.1-.2-.2-.2-.1-.1-.2-.1-.3-.2-.1-.1-.2-.2-.4-.2-.3-.2-.6-.2-1-.2-.2.1-.5.2-.7.4l-.9.3c-.6.1-1.1.3-1.7.4-.3 0-.7.1-1 .1-.1 0-.3.1-.4.1h-.6c-.4 0-.7.1-1.1 0-.1 0-.6.1-.6-.1.2-.1.4-.1.6-.1.3 0 .5 0 .8-.1.8-.1 1.5-.2 2.2-.4.4-.1.7-.2 1.1-.3.2 0 .3-.1.5-.1.2-.1.3-.2.5-.2.2-.1.5-.2.7-.4.1 0 .1-.1.2-.1.1-.2-.2-.3-.4-.4-.1-.1-.3-.1-.4-.2-.2-.1-.5-.1-.7-.2-.3-.1-.6-.2-.8-.2l-.6-.2c-.2 0-.3-.1-.5-.1-.1 0-.2 0-.2-.1h.2c0-.1-.6-.2-.7-.1-.2 0-.4-.1-.7-.1-.2 0-.4.1-.7.1h-1.8c-.1 0-.2 0-.3-.1 0-.1.4-.2.5-.2-.1-.2-.6-.1-.8-.1h-2.2s-.2 0-.2-.1c-.1-.1.1-.2.1-.3.3-.2.6-.3.9-.4 0-.1-.1-.2-.1-.2 2.7-.5 5.4-.1 7.9 1.1.3.1.5.2.8.4h.1c1.7.7 3 2 4.1 3.4Z",
    style: {
      fill: "#1e3a4a"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1403 1288v.9c-.1 1.1-.3 2.2-.6 3.2v-.4c0-.1 0-.2.1-.2v-2.2c0-.1 0-.2.1-.3 0-.3 0-.6-.1-1v-.4q0-.1-.1-.2v-.2c0-.1 0-.2-.1-.2v-.8q0-.1-.1-.2c0-.1-.1-.3-.1-.4-.1-.2-.2-.5-.2-.8s-.1-.5-.2-.8c-.1-.2-.2-.5-.4-.7-.1-.1 0-.2-.1-.4 0-.1-.1-.2-.2-.2-.1-.1-.2-.1-.4-.1-.1 0-.2.1-.4.1 0-.1.2-.2.3-.2s.3 0 .3-.2c0-.1-.1-.2-.2-.3l-.1-.1c0-.1-.1-.1-.2-.1s-.1-.1-.2-.2l-.1-.1-.3-.3c-.2-.2-.5-.3-.7-.3-.1 0-.2 0-.3-.1l-.2-.2c-.1-.1-.1-.2 0-.3l.1-.1v-.2l-.3-.6-.6-.3h-1.8c0-.1.2-.2.3-.2.2-.1.3-.2.5-.3l.3-.3c.1-.1.1-.2.2-.2-.2-.1-.3-.2-.5-.3-.2-.1-.4-.2-.6-.2-.2-.1-.4-.1-.6-.2s-.5-.2-.6-.4c-.1-.2-.3-.3-.5-.4s-.3-.1-.5-.1h-1.3c-.1 0-.2 0-.3-.1-.3-.1-.5-.4-.7-.6-.1-.1-.2-.2-.4-.2-.2-.1-.4-.1-.6-.1h-1.5c-.2 0-.4.1-.6.1-.1 0-.2 0-.3-.1h-.3c-.1-.1.2-.3-.2-.3-.3.1-.7.2-1 .2-.4.1-.7.2-1.1.3l-.6.3c-.3.2-.7.3-1 .4 1.2-.6 2.4-1 3.7-1.2 2.7-.5 5.4-.1 7.9 1.1.3.1.5.2.8.4h.1c1.6.9 2.9 2.1 4 3.6.3.5.6.9.9 1.4.4.6.7 1.3.9 2v.2c.3.8.4 1.7.5 2.5 0 .2 0 .5.1.7.1.4.1.7.1.9Z",
    style: {
      fill: "url(#n)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1403 1287.3c0-.2 0-.5-.1-.7-.1-.9-.3-1.7-.5-2.5v-.2c-.2-.7-.5-1.4-.9-2-.3-.5-.6-1-.9-1.4-1.1-1.5-2.4-2.7-4-3.6h-.1c-.3-.1-.5-.3-.8-.4-2.6-1.2-5.5-1.6-8.3-1s-5.3 2-7.2 4.2c-.1.1-.2.2-.2.3 1.1-1.2 2.4-2.2 3.8-2.9 1.2-.6 2.4-1 3.7-1.2 2.7-.5 5.4-.1 7.9 1.1.2.1.5.2.8.4h.1c1.6.9 2.9 2.1 4 3.6.3.5.6.9.9 1.4.4.6.7 1.3.9 2 0 0 0 .1.1.1v.1c.3.8.4 1.7.5 2.5 0 .2.1.5.1.7v1.6c-.1 1.1-.3 2.2-.6 3.2-.4 1.3-1.1 2.6-1.9 3.7-.1.1-.2.2-.3.4.2-.2.4-.5.6-.8.8-1.1 1.5-2.4 1.9-3.7.4-1 .6-2.1.6-3.2v-.9c-.1-.3-.1-.6-.1-.8Z",
    style: {
      fill: "url(#o)",
      isolation: "isolate",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1394.5 1285h.5c0-.1.1-.1.1-.1-.1-.1-.2-.1-.2-.1-.1 0-.3 0-.4.2ZM1390.9 1279h.5c0-.1.1-.1.1-.1-.1-.1-.2-.1-.2-.1-.1 0-.2 0-.2.1l-.2.1ZM1388.9 1297.1h.5c0-.1.1-.1.1-.1-.1-.1-.2-.1-.2-.1-.1.1-.3.1-.4.2ZM1379.9 1287.3h.5c0-.1.1-.1.1-.1-.1 0-.2-.1-.2-.1-.1 0-.2 0-.2.1l-.2.1Z",
    style: {
      fill: "#4f85aa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1397.7 1292.5.3-.3c0 .1.1.1.2.2v.4c-.1.1-.2.3-.3.3-.1.1-.3.2-.4.2s-.2.1-.3 0l-.1-.1v-.1c.1-.1.2-.1.2-.2.1 0 .2-.1.2-.1l.2-.3Z",
    style: {
      fill: "#101d28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1399 1292.4-.3.3c0 .1.2-.1.2-.1s.1 0 .1-.1c.1.1.1 0 0-.1ZM1396.8 1287.8l-.3.3c0 .1.2-.1.2-.1h.1s.1-.1 0-.2ZM1386.1 1276.1l-.3.3c0 .1.2-.1.2-.1h.1c.1 0 .1-.1 0-.2Z",
    style: {
      fill: "#4f85aa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1380.7 1288.9v.4q0 .1.1.1l.1.1.2.1c.1 0 .1-.1.2-.2v-.3c0-.1-.1-.3-.2-.4h-.2l-.2.2ZM1386.1 1281s-.1.1 0 0q-.1.1 0 0l-.1.2c.1-.1.2-.1.1-.2q.1 0 0 0ZM1386.1 1281.6v.4s0 .1.1.1l.1.1.2.1c.1 0 .1-.1.2-.2 0-.1.1-.2 0-.3 0-.1-.1-.3-.2-.4q-.1 0-.2-.1c-.1.1-.1.2-.2.3Z",
    style: {
      fill: "#101d28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1381.7 1279.8c.2.1.4.1.5 0l.2-.2c.1-.1.2-.1.3-.2v-.3h-.1c-.2-.1-.9 0-.9.3v.4Z",
    style: {
      fill: "#4f85aa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1394.6 1283.9c.2.1.3.1.5 0l.2-.2c.1-.1.2-.1.3-.2v-.3h-.1c-.2-.1-.9 0-.9.3v.4Z",
    style: {
      fill: "#101d28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1380.9 1288.2s.1.3.2.2v-.2h-.2c0-.1.1-.1 0 0q.1-.1 0 0 .1 0 0 0ZM1381.3 1288.7v-.2h.1v.3s-.1 0-.1-.1Z",
    style: {
      fill: "#223f51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1381.9 1296.2c.1.2.2.3.3.4l.3.3c.1.1.3.2.4.3q.1 0 .1-.1l-.3-.3c-.2-.1-.3-.2-.4-.3-.1-.1-.2-.3-.4-.3ZM1382 1296c-.1-.1-.1-.2-.1-.3.1.1.1.2.1.3ZM1398.4 1291.8c.1.1-.1.1 0 0ZM1382.1 1285.2c.1-.1.2-.1.2 0 0 0 0 .1-.2 0 .1.1-.1.1 0 0Z",
    style: {
      fill: "#4f85aa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1382.2 1289.2c.1-.1.2-.2.3-.2h.1c.1 0 .1.1.1.1 0 .1 0 .2-.1.3-.1.1-.4.1-.4-.2Z",
    style: {
      fill: "#223f51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1385.4 1281.2c.1-.1.2-.2.3-.2h.1l.1.1c.1.1 0 .2-.1.2-.2.1-.5.1-.4-.1Z",
    style: {
      fill: "#4f7896"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1395.5 1299 .3-.3c.1 0 .1-.1.2-.1h.2c.1.1.1.2 0 .2-.1.1-.2.2-.3.2-.1.1-.3.1-.4 0Z",
    style: {
      fill: "#4f85aa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "startup_plamet_4",
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M979 1170.5v.5c0 .6-.2 1.3-.4 1.9-.4 1-.9 2-1.7 2.8-.7.7-1.5 1.3-2.4 1.7-.6.2-1.1.4-1.7.5-.4.1-.9.1-1.3.1-1.6 0-3.2-.5-4.4-1.5-.9-.7-1.7-1.6-2.2-2.6l-.3-.6c-.4-.9-.6-1.9-.6-2.9v-1.4c0-.1 0-.2.1-.3v-.2c.1-.2.1-.4.2-.7v-.2q0-.1.1-.2c.1-.1 0-.1.1-.2.2-.3.3-.6.5-1 0 0 0-.1.1-.1l.1-.1c.2-.2.3-.4.5-.7.6-.7 1.4-1.3 2.2-1.8.7-.3 1.4-.6 2.1-.7 1.5-.3 3.1-.1 4.6.6.1.1.3.2.4.2.9.5 1.7 1.2 2.3 2.1.2.3.4.5.5.8.2.4.4.8.5 1.2v.2c.2.5.3 1 .3 1.5v.4c0 .1.4.6.4.7Z",
    style: {
      fill: "url(#p)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M979 1170.5v.5c0 .1-.1.2-.1.2-.1.1-.2.2-.4.2s-.4.1-.6.1c-.3 0-.5.1-.8.2-.5.2-.9.3-1.4.6-.5.2-.9.4-1.4.6-.3.1-.5.1-.8.2-.1 0-.2.1-.4.1s-.3.1-.5.1-.4.1-.7.2-.5.1-.8.2h-2.4c-.2 0-.4-.1-.6-.1-.2-.1-.4-.1-.6-.1h-.8c-.2 0-.4-.1-.5-.2-.2-.1-.4-.1-.6-.2-.2-.1-.4-.1-.6-.1h-.3l-.1.1-.1.1h-.3c-.4-.9-.6-1.9-.6-2.8v-1.4c0-.1 0-.2.1-.3v-.2c.1-.2.1-.4.2-.7v-.2s0-.1.1-.2c0 0 0-.1.1-.2.2-.3.3-.6.5-1 0 0 0-.1.1-.1l.1-.1c.2-.2.3-.4.5-.7-.1.2-.1.3-.1.5v.1c.1-.1.1-.2.2-.3l.3-.3c.1-.1.2-.2.2-.3l.1-.1q0 .1-.1.2t-.1.2v.1l.1-.1s.1-.1.2-.1c.1-.1.2-.1.2-.2.2-.2.4-.3.7-.5.2-.1.5-.3.7-.4.1-.1.3-.1.4-.2.1 0 .2-.1.3-.1h.9c0 .1-.1 0-.2.1l-.2.2-.2.2-.2.2v.1h.1c.1 0 .2 0 .3-.1.1 0 .3-.1.4-.1s.2-.1.3-.1.2 0 .3-.1h.4c.1 0 0 .1 0 .1-.2.1-.3.2-.5.2s-.4.1-.6.1c-.1.1-.3.1-.4.2l-.2.1c-.1.1-.2.1-.3.2-.2.1-.3.2-.5.3-.1.1-.3.2-.4.3l-.3.3c-.1.1-.2.2-.2.3-.1.1-.1.3-.1.4v.2c0 .1.1.1.1.1.1.1.2.1.4.1h.3c.1 0 .3-.1.4-.1h.5c.2 0 .3.1.5.1.2.1.3.2.4.3.2.1.4.3.6.5l.3.3c.1.1.2.1.2.2l.6.3c.2 0 .4.1.6 0 .1 0 .3-.1.4-.1h1s.1 0 .1.1c-.1.1-.2 0-.3 0h-.4s-.2 0-.2.1.2.1.2.1h.9c.2 0 .3.1.5.1h.2c.1 0 .2 0 .3-.1.2-.1.3-.1.5-.2h.9c.2 0 .4 0 .6-.1.2-.1.5-.2.7-.3.2 0 .3-.1.5-.1h.2q.1 0 .1-.1t.1-.1v-.2l.1-.2v.1c.2.5.3 1 .3 1.5q-.1 0-.2-.1c-.1-.1-.2 0-.3-.1h-.2c-.2 0-.3 0-.5.1-.1 0-.2.1-.2.1-.1 0-.1.1-.2.1s-.1.1-.2.1-.2.1-.3.2c-.2.1-.4.1-.6.2-.2 0-.3.1-.5.1h-2.1c-.1 0-.2 0-.3.1 0 0-.1 0-.1.1h.7c.3 0 .5 0 .8.1h.5c.2 0 .4-.1.6-.1.4-.1.8-.1 1.1-.2.2 0 .4-.1.5-.1h.5c.2 0 .3-.1.5-.1h.3c.8.5.8.7.8.8Z",
    style: {
      fill: "#070d18"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M977.5 1175c-1.1 1.5-2.8 2.5-4.7 2.9l-.3-.3c-.1-.1-.2-.2-.4-.3-.2-.2-.5-.3-.7-.5-.3-.2-.5-.3-.8-.4-.2-.1-.3-.1-.5-.2-.2 0-.4-.1-.6-.1-.7-.1-1.3 0-2 .2-.1 0-.3.1-.4.2-.9-.7-1.7-1.6-2.2-2.6q.1 0 .2-.1h.2c.1 0 .2 0 .3.1.2.1.5.2.8.1h.2q.1 0 .2-.1h1.1c.1 0 .3-.1.4-.1h.3c.3 0 .6 0 .8.2.2 0 .3.1.5.1h.5c.3 0 .5 0 .8-.1h.3c.2 0 .4-.1.6-.1.5-.1.9-.2 1.3-.3.2-.1.4-.1.6-.2.1 0 .2 0 .2-.1h.2c0 .1-.1.1-.2.1s-.1.1-.2.1-.3.1-.4.2c-.1 0-.2 0-.3.1-.1 0-.2.1-.3.1s-.2.1-.2.1c-.1.1-.2.1-.4.1-.3.2-.6.3-.9.4-.1 0-.2.1-.3.1 0 0-.1 0-.1.1s.1.1.2.1.2.1.3.1.1 0 .2.1.2.1.3.1c.2.1.5.1.7.1.3 0 .7-.1 1-.1.1 0 .3 0 .4.1.1 0 .3.1.4.1.4 0 .7.1 1.1 0 .3 0 .5 0 .8-.1.2 0 .3-.1.5-.1.1 0 .2 0 .2-.1l.1-.1c.1.2.1.1.2.1Z",
    style: {
      fill: "#070d18"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M978.6 1172.9c-.1.3-.2.5-.3.8-.1 0-.2.1-.2.2q-.1.1-.2.1l-.1.1-.1.1c-.1 0-.2.1-.2.2 0 0 0 .1-.1.1h-.1l-.1.1c-.1.1-.2.1-.3.2-.1 0-.1.1-.2.1s-.2 0-.2.1c-.1 0-.2.1-.2.1-.1 0-.2 0-.3.1h-.6q-.1 0-.2.1h-2q0-.1.1-.1h.9c.1 0 .2 0 .2.1.2.1.5.1.8.1h.1s.1 0 .2-.1c.1 0 .3-.1.4-.1s.1-.1.2-.1.1-.1.2-.1.1-.1.2-.1l.2-.1c.1-.1.3-.1.4-.2.1-.1.2-.2.4-.2.1-.1.3-.2.4-.3.1-.1.2-.1.3-.2.1 0 .1-.1.2-.1.1-.1.1-.2.1-.2 0-.1.1-.1.2-.2l.1-.1-.2-.4Z",
    style: {
      fill: "#070d18"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M978.1 1166.9c-.2.2-.3.3-.6.4s-.6.1-.9.1h-.8c-.2 0-.3.1-.5.1h-.6c0-.1.2-.1.3-.2s.3-.1.5-.1h.5s.3-.1.3-.2-.1-.1-.1-.1-.1-.1-.2-.1-.2 0-.1-.1.1-.2 0-.2h-.5c-.1 0-.1.1-.2.1h-.4c-.3 0-.6.2-.8.1l-.3-.1h-.5c-.2 0-.4.1-.6.1-.1 0-.3.1-.4 0 0-.1.2-.1.2-.1.2 0 .4-.1.5-.1.2 0 .4-.1.6-.1h.4c.3 0 .7-.1 1-.2s.6-.4.8-.6c.1-.1.3-.2.3-.4 0-.1.1-.2.1-.3v-.3c.9.7 1.5 1.5 2 2.3Z",
    style: {
      fill: "#070d18"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M964.9 1167.4c.1-.2.1-.4.2-.5l.1-.1c.1 0 .1-.2.2-.2s0 .2.1.2.2-.2.3-.2.1-.1.2-.1 0 0 0 .1c0 0 .1 0 .1-.1.1-.1.2-.2.3-.2s.3-.2.3-.1c.1.1-.1.3-.2.3-.1.2-.2.3-.3.5 0 .1 0 .3.1.4l.3.3c.1 0 .1.1.2.1s.2.1.3.1c.2.1.4.1.7.2h.7c.1-.1.3-.1.4 0 .1 0 .1.1.2.2s.2.1.3.2.2.1.4.2c.1 0 .1.1.2.1s.1.1.2.1.1.1.1.1q0 .1.1.2c0 .1-.1.1-.1.2.1.1.2.1.3.2l.1.1c0 .1-.2.1-.3.1h-1.3c-.2 0-.3 0-.5.1h-.2c.1.1.2.1.3.1.2 0 .4.1.7.1.2 0 .4.1.6.2.1 0 .2.1.2.1h.3c.5 0 .9-.1 1.4-.1h.5c.2 0 .3-.1.4-.1s.2 0 .3-.1c.1 0 .2-.1.3-.1.2 0 .3-.1.5-.1h.4c.2 0 .4-.1.7-.2l1.2-.3c.2 0 .3-.1.5-.1h.2c.1 0 .2-.1.2-.1.1-.1.2-.2.3-.2.1-.1.3-.1.4-.1 0 0 .1 0 .1-.1h.1c-.1.1-.2.1-.3.1s-.2.1-.3.2c0 .1-.1.1-.2.1-.1.1-.3.2-.4.2-.2.1-.5.2-.7.2-.2.1-.5.1-.8.2-.5.1-1.1.2-1.7.3-.2 0-.4.1-.7.1-.1 0-.2.1-.2.1-.1 0-.2.1-.3.1-.2.1-.4.1-.6.2-.1 0-.3 0-.3.2.1 0 .2.1.3 0h.2c.1 0 .2-.1.2-.1.1 0 .1-.1.2-.1s.1-.1.2-.1h.2s-.1.1-.2.1c0 0-.1 0-.2.1-.1 0-.1.1 0 .1h.3c.3 0 .6-.1 1-.1.2 0 .4.1.6.1h.7c.2 0 .4-.1.7-.1.1 0 .2 0 .4-.1.2 0 .3 0 .5-.1.2 0 .4-.1.6-.1s.3 0 .5-.1h.2s.1 0 .1.1c0 0 .1 0 .1.1-.3.2-.8.3-1.2.4-.3.1-.5.2-.8.2l-.9.3-.9.3c-.2.1-.5.2-.7.2-.1 0-.2.1-.3.1s-.2.1-.4.1c-.1 0-.2.1-.3.1s-.2.1-.4.1c-.1 0-.3.1-.4.1-.1.1-.2.1-.3.1-.2 0-.3.1-.5.1-.1 0-.2.1-.4.1h-2.1 1c.1 0 .3 0 .4-.1.1 0 .1-.1.2-.1s.1-.1.2-.1.2 0 .3-.1h.2c.1 0 .2 0 .3-.1.2-.1.3-.1.5-.2.1 0 .2-.1.2-.2.1-.2-.1-.1-.2-.1-.2.1-.4.1-.7.2h-1.6c-.2 0-.4.1-.6.1h-.4c-.2 0-.4.1-.6.1-.1 0-.2.1-.3.1h-.4c-.2 0-.4-.1-.6-.1-.3-.1-.5-.2-.7-.4-.2-.2-.5-.3-.7-.4-.2 0-.4 0-.6.1-.2.1-.3.1-.5.1s-.1-.2-.1-.3v-1c0-.1.1-1.1.3-1.1v.2c0 .1.1.1.1.2l.1-.2c0-.2.1-.3.1-.5s.1-.4 0-.6c0-.1 0-.2-.1-.2h-.1c-.1 0-.2-.1-.2-.2 0-.2 0-.3.1-.4s.1-.3.2-.4c.6.5.6.4.6.4Z",
    style: {
      fill: "#070d18"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M976.9 1175.7c-.7.7-1.5 1.3-2.4 1.7-.1-.1-.3-.1-.4-.1s-.3 0-.3-.1c-.1-.1.1-.1.2-.1s.2 0 .2-.1c.1-.2-.6-.2-.7-.3-.2 0-.4-.1-.6 0-.1 0-.2 0-.4-.1-.1 0-.2 0-.3-.1-.2-.1-.4-.1-.7-.1 0 0-.3 0-.3-.1.1 0 .2-.1.4-.1h.3c.5.1 1.1.2 1.6.1h.4c.2 0 .4 0 .5-.1.2 0 .3-.1.5-.1 0 0 .2 0 .2-.1h-1.2c-.1 0-.2 0-.3-.1 0-.1.2-.1.2-.1.1 0 .3 0 .4-.1.4-.1.7-.1 1.1-.1h1.4q.1.1.2.1Z",
    style: {
      fill: "#070d18"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M967.8 1168.4c0 .1-.1.3 0 .4 0 .1.1.1.1.1.2.1.3.1.5.1.1 0 .3-.1.4-.1.1-.1.1-.2.2-.3v-.2q0-.1-.1-.1t-.1-.1h-.8c0 .2-.1.2-.2.2Z",
    style: {
      fill: "#223648"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M969.1 1168.9s.1-.1.2-.1c0 0 .1 0 .1.1v.2h-.2c0-.1 0-.2-.1-.2Z",
    style: {
      fill: "#223648"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M968.7 1169.2c.1 0 .1-.1.2-.1h.3s0 .1.1.1v.2q0 .1-.1.2c-.1.1-.2.1-.2.2-.1 0-.2.1-.3.1s-.1 0-.2-.1h-.2c-.1 0-.2-.1-.2-.2s.1-.1.1-.1.1-.1.2-.1h.1c.1-.1.1-.2.2-.2Z",
    style: {
      fill: "#223648"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M969.6 1169c0 .1-.1.1-.1.2s.1 0 .1-.2Z",
    style: {
      fill: "#223648"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M970.4 1170.6c-.3 0-.5-.1-.8-.1s-.6.1-.8.3c-.1.1-.2.2-.2.3v.1l.1.1c.1.1.3.1.4.2.1 0 .3.1.4.1h.4c.1 0 .3 0 .4-.1.1 0 .2-.1.3-.2 0-.1.1-.1.1-.2v-.2q0-.1-.1-.2l-.1-.1h-.1Z",
    style: {
      fill: "#223648"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M971 1170.6c0 .1.1.1.1.2h.3q.1 0 .1-.1c0-.1-.1-.1-.2-.1 0 0-.1-.1-.3 0Z",
    style: {
      fill: "#223648"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M968.8 1171.7h.6q.1 0 .1.1v.1l-.1.1c-.1 0-.2.1-.2.1-.2.1-.3.1-.5.1h-.1l-.1-.1v-.2l.1-.1h.1q0-.1.1-.1Z",
    style: {
      fill: "#223648"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M964.5 1171.3v.6s0 .1.1.1h.2c.1 0 .2-.1.3-.1s.1-.1.1-.2c.1-.1.1-.2.1-.3v-.4c0-.1-.1-.2-.1-.3s0-.1-.1-.1h-.2c-.1 0-.2.1-.3.1s-.1.1-.1.1q0 .1-.1.2v.2c.1-.1.1 0 .1.1Z",
    style: {
      fill: "#223648"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M964.9 1170.2c0-.1-.1-.2 0-.2s.1.1 0 .2c.2 0 .1 0 0 0Z",
    style: {
      fill: "#223648"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M965.1 1169.6c0-.2-.1-.4 0-.6 0-.1.1-.1.2-.1l.1.1c0 .1.1.1.1.2v.4s0 .1-.1.1l-.1.1h-.2q.1-.1 0-.2Z",
    style: {
      fill: "#223648"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M965 1168.6q0 .1.1.2h.1s.1 0 .1-.1v-.2l-.1-.1c-.2 0-.2.1-.2.2Z",
    style: {
      fill: "#223648"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M971.9 1171.6c.1 0 .2-.1.3-.1h.2c.1 0 .3-.1.4-.1h.4c.2 0 .3-.1.5-.1h.6c.3 0 .7.1 1 .2.1 0 .2 0 .2.1h.3c.1 0 .1-.1 0-.2s-.2-.1-.3-.1h-.2c-.1 0-.2 0-.2.2v.2c0 .1-.1.2-.2.2 0 0-.1 0-.1.1 0 0-.1 0-.1.1-.1 0-.1.1-.2.1 0 0-.1 0-.1.1-.1.1-.3.1-.4.1s-.2.1-.3.1-.1 0-.2.1h-.2c-.2.1-.4.1-.6.1q-.1 0-.2-.1c0-.1-.1-.1-.1-.2s-.1-.2-.1-.2c-.1 0-.2-.1-.3-.1l-.1-.1v-.2c-.1-.1-.1-.2 0-.2Z",
    style: {
      fill: "#223648"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M975.8 1171.2q.1 0 .2-.1h.2v.1h-.4q.1 0 0 0Z",
    style: {
      fill: "#223648"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M969.9 1174.8c-.2 0-.4 0-.6.1-.1 0-.1.1-.2.2s.1.2.2.2c.2 0 .4.1.6.2.2.1.3.1.5.1.1 0 .2-.1.3-.2v-.2c0-.1-.1-.1-.1-.1-.1-.1-.2-.2-.4-.2 0-.2-.2-.2-.3-.1Z",
    style: {
      fill: "#223648"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M969.6 1174.5s-.1 0 0 0l.3.1s.1 0 .1-.1v-.2h-.2c-.1.2-.2.2-.2.2Z",
    style: {
      fill: "#223648"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M968.7 1175.3h.3c.1 0 .2 0 .2.1h.2v.1c0 .2-.2.2-.4.2h-.3c-.1 0-.2 0-.4-.1-.1 0-.2 0-.2-.1h-.1l-.1-.1v-.3h.1c.1-.1.3-.1.4 0h.2c0 .1 0 .2.1.2Z",
    style: {
      fill: "#223648"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M972.1 1166.9c-.1 0-.2.1-.3.1h-1.2c-.1 0-.2-.1-.3-.1h-.3c-.1 0-.2 0-.3-.1h-.1v-.1h.1c.1 0 .2.1.3.1.1.1.3 0 .5.1h.2s.1 0 .1.1h.2c.1 0 .2-.1.4-.1.1-.1.3-.1.4-.1h.4s.1 0 .1.1l.1.1c-.2-.2-.3-.2-.3-.1Z",
    style: {
      fill: "#070d18"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M971.6 1164.6h.2-.2c.1 0 0 0 0 0h-.2c.1-.1.2 0 .2 0Z",
    style: {
      fill: "#070d18"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M975.2 1164c-.1.1-.1.2-.2.3-.1.1-.2.2-.3.2-.1.1-.3.1-.4.2-.2 0-.3.1-.5.1h-.3c-.1 0-.3 0-.4-.1h-.3c-.1 0-.2-.1-.3-.1h-.5 1.6c.1 0 0 0 0 0v-.1s-.2-.1-.2-.2h1.3c.1 0 .1-.1.2-.1l.1-.1s0-.1.1-.1c-.2-.2-.1-.1.1 0 0 0-.1 0 0 0Z",
    style: {
      fill: "#070d18"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m975.2 1164.4-.3.3c-.1.1-.2.1-.4.2-.1 0-.2.1-.3.1h-.2v.1h.3c.2 0 .4 0 .5-.1.1 0 .2-.1.3-.1l.3-.3c0-.1.1-.2 0-.2q-.1-.1-.2 0c0-.1-.1-.1 0 0Z",
    style: {
      fill: "#070d18"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M977.6 1166.1c-.2 0-.3-.1-.5-.1 0 0-.3-.2-.1-.2 0 0-.1-.1-.1-.2l-.1-.1s-.1-.1-.2-.1-.1-.1-.2-.1c-.2-.1-.4-.1-.5-.1s-.3.1-.4.2c-.2.1-.3.2-.5.2-.3.1-.6.2-1 .2-.2 0-.4 0-.6.1h-1.1c-.1 0-.3 0-.4-.1.1 0 .2-.1.3-.1h.5c.4-.1.9-.1 1.3-.3.2 0 .4-.1.6-.2.1 0 .2 0 .3-.1.1 0 .2-.1.3-.1s.3-.1.4-.2c0 0 .1 0 .1-.1.1-.1-.1-.2-.2-.2s-.2-.1-.2-.1c-.1 0-.3-.1-.4-.1-.2-.1-.3-.1-.5-.1l-.4-.1c-.1 0-.2 0-.3-.1 0 0-.1 0-.1-.1h.1c0-.1-.4-.1-.4-.1h-2.1c0-.1.2-.1.3-.1 0-.1-.4-.1-.4-.1h-1.3c0-.1.1-.1.1-.2.2-.1.3-.2.5-.2v-.1c1.5-.3 3.1-.1 4.6.6.1.1.3.2.4.2.8.6 1.5 1.3 2.2 2.2Z",
    style: {
      fill: "#1e3a4a"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M979 1170.5v.5c0 .6-.2 1.3-.4 1.9v-1.9c0-.2 0-.4-.1-.6v-1.2c0-.1-.1-.2-.1-.2-.1-.1-.1-.3-.1-.5 0-.1-.1-.3-.1-.4-.1-.1-.1-.3-.3-.4-.1-.1 0-.1 0-.2s-.1-.1-.1-.1c-.1 0-.1-.1-.2-.1s-.1.1-.2 0c0 0 .1-.1.2-.1 0 0 .2 0 .2-.1s-.1-.1-.1-.2c0 0 0-.1-.1-.1 0 0-.1 0-.1-.1l-.1-.1s0-.1-.1-.1l-.2-.2c-.1-.1-.3-.1-.4-.2q-.1 0-.2-.1l-.1-.1v-.2s0-.1.1-.1v-.1c0-.1-.1-.3-.2-.4-.1-.1-.2-.1-.3-.1h-1.1c0-.1.1-.1.2-.1s.2-.1.3-.2c.1 0 .1-.1.2-.2l.1-.1c-.1-.1-.2-.1-.3-.2s-.2-.1-.4-.1c-.1 0-.2-.1-.3-.1s-.3-.1-.4-.2c-.1-.1-.2-.2-.3-.2s-.2-.1-.3-.1h-1c-.2 0-.3-.2-.4-.3q-.1-.1-.2-.1c-.1 0-.2-.1-.4-.1h-.8c-.1 0-.2.1-.4.1h-.4c-.1 0 .1-.2-.1-.2s-.4.1-.6.1-.4.1-.6.2c-.1 0-.2.1-.4.2s-.4.2-.6.2c.7-.3 1.4-.6 2.1-.7 1.5-.3 3.1-.1 4.6.6.1.1.3.2.4.2.9.5 1.7 1.2 2.3 2.1.2.3.4.5.5.8.2.4.4.8.5 1.2v.2c.2.5.3 1 .3 1.5v.4c0 .1.5.5.5.6Z",
    style: {
      fill: "url(#q)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M979 1170.1v-.4l-.3-1.5v-.2c-.1-.4-.3-.8-.5-1.2-.2-.3-.3-.6-.5-.8-.6-.8-1.4-1.5-2.3-2.1-.1-.1-.3-.2-.4-.2-1.5-.7-3.2-.9-4.8-.6s-3.1 1.2-4.1 2.4c0 .1-.1.1-.1.2.6-.7 1.4-1.3 2.2-1.7.7-.4 1.4-.6 2.1-.7 1.5-.3 3.1 0 4.6.6.1.1.3.1.4.2.9.5 1.7 1.2 2.3 2.1.2.3.4.5.5.8.2.4.4.8.5 1.2v.2c.2.5.3 1 .3 1.5v1.3c0 .6-.2 1.2-.4 1.8-.3.8-.6 1.5-1.1 2.1l-.2.2c.1-.1.2-.3.4-.4.5-.6.9-1.4 1.1-2.1.2-.6.3-1.2.4-1.8v-.5c-.1-.1-.1-.3-.1-.4Z",
    style: {
      fill: "url(#r)",
      isolation: "isolate",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M974.1 1168.8h.3v-.1h-.1s-.1 0-.2.1ZM972 1165.3h.3v-.1h-.1s-.1 0-.2.1ZM970.9 1175.8h.3v-.1h-.1c-.1 0-.2 0-.2.1ZM965.7 1170.1h.3v-.1h-.1s-.1 0-.2.1Z",
    style: {
      fill: "#4f85aa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976 1173.1c0-.1.1-.1.2-.2 0 0 .1 0 .1.1v.2c0 .1-.1.1-.2.2s-.2.1-.2.1h-.2v-.2l.1-.1s.1 0 .1-.1h.1Z",
    style: {
      fill: "#101d28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m976.7 1173-.2.2h.2c0-.1.1-.1 0-.2ZM975.4 1170.4l-.2.2h.2c0-.1.1-.2 0-.2ZM969.2 1163.7l-.2.2h.2c.1-.1.1-.2 0-.2Z",
    style: {
      fill: "#4f85aa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M966.1 1171v.3s.1 0 .1.1l.1.1s.1 0 .1-.1v-.2c0-.1-.1-.2-.1-.2h-.2q.1 0 0 0ZM969.2 1166.5q.1.1 0 0 .1 0 0 0 .1 0 0 0 .1 0 0 0ZM969.3 1166.8v.2s.1 0 .1.1c0 0 .1.1.1 0 0 0 .1 0 .1-.1v-.2c0-.1-.1-.2-.1-.2h-.1q-.1.1-.1.2Z",
    style: {
      fill: "#101d28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M966.7 1165.8h.3s.1 0 .1-.1c.1 0 .1-.1.2-.1-.1 0-.5 0-.6.2Z",
    style: {
      fill: "#4f85aa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M974.1 1168.1h.3l.1-.1c.1 0 .1-.1.2-.1v-.1c-.1-.1-.5 0-.6.3Z",
    style: {
      fill: "#101d28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M966.3 1170.6s.1.2 0 0c.1 0 0-.1 0 0q0-.1 0 0ZM966.5 1170.9s0-.1 0 0q0-.1 0 0c.1-.1.1 0 0 0 .1 0 .1.1 0 0q.1.1 0 0 0 .1 0 0Z",
    style: {
      fill: "#223f51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M966.8 1175.2c.1.1.1.2.2.2q.1.1.1.2c.1.1.2.1.2.2 0 0 .1 0 0 0 0-.1-.1-.1-.2-.2s-.2-.1-.2-.2c.1-.1 0-.2-.1-.2ZM966.9 1175.1c0-.1-.1-.1-.1-.2q.1.1.1.2ZM976.3 1172.7s.1-.1 0 0ZM966.9 1168.9s.1-.1 0 0c.1.1 0 .1 0 0Z",
    style: {
      fill: "#4f85aa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M967 1171.2s.1-.1.2-.1h.1l.1.1q0 .1-.1.2c-.1-.1-.3 0-.3-.2Z",
    style: {
      fill: "#223f51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M968.8 1166.6s.1-.1.2-.1h.1l.1.1q0 .1-.1.2c-.1-.1-.3-.1-.3-.2Z",
    style: {
      fill: "#4f7896"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M974.7 1176.8c0-.1.1-.1.2-.2 0 0 .1 0 .1-.1v.1c0 .1-.1.1-.3.2.1.1 0 .1 0 0Z",
    style: {
      fill: "#4f85aa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "startup_plamet_3",
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100 1353.5v.5c0 .6-.2 1.3-.4 1.9-.4 1-.9 2-1.7 2.8-.7.7-1.5 1.3-2.4 1.7-.6.2-1.1.4-1.7.5-.4.1-.9.1-1.3.1-1.6 0-3.2-.5-4.4-1.5-.9-.7-1.7-1.6-2.2-2.6l-.3-.6c-.4-.9-.6-1.9-.6-2.9v-1.4c0-.1 0-.2.1-.3v-.2c.1-.2.1-.4.2-.7v-.2q0-.1.1-.2c.1-.1 0-.1.1-.2.2-.3.3-.6.5-1 0 0 0-.1.1-.1l.1-.1c.2-.2.3-.4.5-.7.6-.7 1.4-1.3 2.2-1.8.7-.3 1.4-.6 2.1-.7 1.5-.3 3.1-.1 4.6.6.1.1.3.2.4.2.9.5 1.7 1.2 2.3 2.1.2.3.4.5.5.8.2.4.4.8.5 1.2v.2c.2.5.3 1 .3 1.5v.4c0 .1.4.6.4.7Z",
    style: {
      fill: "url(#s)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100 1353.5v.5c0 .1-.1.2-.1.2-.1.1-.2.2-.4.2s-.4.1-.6.1c-.3 0-.5.1-.8.2-.5.2-.9.3-1.4.6-.5.2-.9.4-1.4.6-.3.1-.5.1-.8.2-.1 0-.2.1-.4.1s-.3.1-.5.1-.4.1-.7.2c-.3.1-.5.1-.8.2h-2.4c-.2 0-.4-.1-.6-.1-.2-.1-.4-.1-.6-.1h-.8c-.2 0-.4-.1-.5-.2-.2-.1-.4-.1-.6-.2s-.4-.1-.6-.1h-.3l-.1.1-.1.1h-.3c-.4-.9-.6-1.9-.6-2.8v-1.4c0-.1 0-.2.1-.3v-.2c.1-.2.1-.4.2-.7v-.2s0-.1.1-.2c0 0 0-.1.1-.2.2-.3.3-.6.5-1 0 0 0-.1.1-.1l.1-.1c.2-.2.3-.4.5-.7-.1.2-.1.3-.1.5v.1c.1-.1.1-.2.2-.3l.3-.3c.1-.1.2-.2.2-.3l.1-.1q0 .1-.1.2t-.1.2v.1l.1-.1s.1-.1.2-.1c.1-.1.2-.1.2-.2.2-.2.4-.3.7-.5.2-.1.5-.3.7-.4.1-.1.3-.1.4-.2.1 0 .2-.1.3-.1h.9c0 .1-.1 0-.2.1l-.2.2-.2.2-.2.2v.1h.1c.1 0 .2 0 .3-.1.1 0 .3-.1.4-.1s.2-.1.3-.1.2 0 .3-.1h.4c.1 0 0 .1 0 .1-.2.1-.3.2-.5.2s-.4.1-.6.1c-.1.1-.3.1-.4.2l-.2.1c-.1.1-.2.1-.3.2-.2.1-.3.2-.5.3-.1.1-.3.2-.4.3l-.3.3c-.1.1-.2.2-.2.3-.1.1-.1.3-.1.4v.2c0 .1.1.1.1.1.1.1.2.1.4.1h.3c.1 0 .3-.1.4-.1h.5c.2 0 .3.1.5.1.2.1.3.2.4.3.2.1.4.3.6.5l.3.3c.1.1.2.1.2.2l.6.3c.2 0 .4.1.6 0 .1 0 .3-.1.4-.1h1s.1 0 .1.1c-.1.1-.2 0-.3 0h-.4c-.1 0-.2 0-.2.1s.2.1.2.1h.9c.2 0 .3.1.5.1h.2c.1 0 .2 0 .3-.1.2-.1.3-.1.5-.2h.9c.2 0 .4 0 .6-.1s.5-.2.7-.3c.2 0 .3-.1.5-.1h.2q.1 0 .1-.1t.1-.1v-.2l.1-.2v.1c.2.5.3 1 .3 1.5q-.1 0-.2-.1c-.1-.1-.2 0-.3-.1h-.2c-.2 0-.3 0-.5.1-.1 0-.2.1-.2.1-.1 0-.1.1-.2.1s-.1.1-.2.1-.2.1-.3.2c-.2.1-.4.1-.6.2-.2 0-.3.1-.5.1h-2.1c-.1 0-.2 0-.3.1 0 0-.1 0-.1.1h.7c.3 0 .5 0 .8.1h.5c.2 0 .4-.1.6-.1.4-.1.8-.1 1.1-.2.2 0 .4-.1.5-.1h.5c.2 0 .3-.1.5-.1h.3c.8.5.8.7.8.8Z",
    style: {
      fill: "#070d18"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.5 1358c-1.1 1.5-2.8 2.5-4.7 2.9l-.3-.3c-.1-.1-.2-.2-.4-.3-.2-.2-.5-.3-.7-.5-.3-.2-.5-.3-.8-.4-.2-.1-.3-.1-.5-.2-.2 0-.4-.1-.6-.1-.7-.1-1.3 0-2 .2-.1 0-.3.1-.4.2-.9-.7-1.7-1.6-2.2-2.6q.1 0 .2-.1h.2c.1 0 .2 0 .3.1.2.1.5.2.8.1h.2q.1 0 .2-.1h1.1c.1 0 .3-.1.4-.1h.3c.3 0 .6 0 .8.2.2 0 .3.1.5.1h.5c.3 0 .5 0 .8-.1h.3c.2 0 .4-.1.6-.1.5-.1.9-.2 1.3-.3.2-.1.4-.1.6-.2.1 0 .2 0 .2-.1h.2c0 .1-.1.1-.2.1s-.1.1-.2.1-.3.1-.4.2c-.1 0-.2 0-.3.1-.1 0-.2.1-.3.1s-.2.1-.2.1c-.1.1-.2.1-.4.1-.3.2-.6.3-.9.4-.1 0-.2.1-.3.1 0 0-.1 0-.1.1s.1.1.2.1.2.1.3.1.1 0 .2.1.2.1.3.1c.2.1.5.1.7.1.3 0 .7-.1 1-.1.1 0 .3 0 .4.1.1 0 .3.1.4.1.4 0 .7.1 1.1 0 .3 0 .5 0 .8-.1.2 0 .3-.1.5-.1.1 0 .2 0 .2-.1l.1-.1c.1.2.1.1.2.1Z",
    style: {
      fill: "#070d18"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.6 1355.9c-.1.3-.2.5-.3.8-.1 0-.2.1-.2.2q-.1.1-.2.1l-.1.1-.1.1c-.1 0-.1.1-.2.2 0 0 0 .1-.1.1h-.1l-.1.1c-.1.1-.2.1-.3.2-.1 0-.1.1-.2.1s-.2 0-.2.1c-.1 0-.2.1-.2.1-.1 0-.2 0-.3.1h-.6q-.1 0-.2.1h-2q0-.1.1-.1h.9c.1 0 .2 0 .2.1.2.1.5.1.8.1h.1s.1 0 .2-.1c.1 0 .3-.1.4-.1s.1-.1.2-.1.1-.1.2-.1.1-.1.2-.1l.2-.1c.1-.1.3-.1.4-.2s.2-.2.4-.2c.1-.1.3-.2.4-.3.1-.1.2-.1.3-.2.1 0 .1-.1.2-.1.1-.1.1-.2.1-.2 0-.1.1-.1.2-.2l.1-.1-.2-.4Z",
    style: {
      fill: "#070d18"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.1 1349.9c-.2.2-.3.3-.6.4-.3.1-.6.1-.9.1h-.8c-.2 0-.3.1-.5.1h-.6c0-.1.2-.1.3-.2.1-.1.3-.1.5-.1h.5s.3-.1.3-.2-.1-.1-.1-.1-.1-.1-.2-.1-.2 0-.1-.1.1-.2 0-.2h-.5c-.1 0-.1.1-.2.1h-.4c-.3 0-.6.2-.8.1l-.3-.1h-.5c-.2 0-.4.1-.6.1-.1 0-.3.1-.4 0 0-.1.2-.1.2-.1.2 0 .4-.1.5-.1.2 0 .4-.1.6-.1h.4c.3 0 .7-.1 1-.2s.6-.4.8-.6c.1-.1.3-.2.3-.4 0-.1.1-.2.1-.3v-.3c.9.7 1.5 1.5 2 2.3Z",
    style: {
      fill: "#070d18"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.9 1350.4c.1-.2.1-.4.3-.5l.1-.1c.1 0 .1-.2.2-.2s0 .2.1.2.2-.2.3-.2.1-.1.2-.1 0 0 0 .1c0 0 .1 0 .1-.1.1-.1.2-.2.3-.2s.3-.2.3-.1c.1.1-.1.3-.2.3-.1.2-.2.3-.3.5 0 .1 0 .3.1.4l.3.3c.1 0 .1.1.2.1s.2.1.3.1c.2.1.4.1.7.2h.7c.1-.1.3-.1.4 0 .1 0 .1.1.2.2s.2.1.3.2c.1.1.2.1.4.2.1 0 .1.1.2.1s.1.1.2.1.1.1.1.1c0 .1.1.1.1.2s-.1.1-.1.2c.1.1.2.1.3.2l.1.1c0 .1-.2.1-.3.1h-1.3c-.2 0-.3 0-.5.1h-.2c.1.1.2.1.3.1.2 0 .4.1.7.1.2 0 .4.1.6.2.1 0 .2.1.2.1h.3c.5 0 .9-.1 1.4-.1h.5c.2 0 .3-.1.4-.1s.2 0 .3-.1c.1 0 .2-.1.3-.1.2 0 .3-.1.5-.1h.4c.2 0 .4-.1.7-.2l1.2-.3c.2 0 .3-.1.5-.1h.2c.1 0 .2-.1.2-.1.1-.1.2-.2.3-.2.1-.1.3-.1.4-.1 0 0 .1 0 .1-.1h.1c-.1.1-.2.1-.3.1s-.2.1-.3.2c0 .1-.1.1-.2.1-.1.1-.3.2-.4.2-.2.1-.5.2-.7.2-.2.1-.5.1-.8.2-.5.1-1.1.2-1.7.3-.2 0-.4.1-.7.1-.1 0-.2.1-.2.1-.1 0-.2.1-.3.1-.2.1-.4.1-.6.2-.1 0-.3 0-.3.2.1 0 .2.1.3 0h.2c.1 0 .2-.1.2-.1.1 0 .1-.1.2-.1s.1-.1.2-.1h.2s-.1.1-.2.1c0 0-.1 0-.2.1-.1 0-.1.1 0 .1h.3c.3 0 .6-.1 1-.1.2 0 .4.1.6.1h.7c.2 0 .4-.1.7-.1.1 0 .2 0 .4-.1.2 0 .3 0 .5-.1.2 0 .4-.1.6-.1s.3 0 .5-.1h.2s.1 0 .1.1c0 0 .1 0 .1.1-.3.2-.8.3-1.2.4-.3.1-.5.2-.8.2l-.9.3-.9.3c-.2.1-.5.2-.7.2-.1 0-.2.1-.3.1s-.2.1-.4.1c-.1 0-.2.1-.3.1s-.2.1-.4.1c-.1 0-.3.1-.4.1-.1.1-.2.1-.3.1-.2 0-.3.1-.5.1-.1 0-.2.1-.4.1h-2.1 1c.1 0 .3 0 .4-.1.1 0 .1-.1.2-.1s.1-.1.2-.1.2 0 .3-.1h.2c.1 0 .2 0 .3-.1.2-.1.3-.1.5-.2.1 0 .2-.1.2-.2.1-.2-.1-.1-.2-.1-.2.1-.4.1-.7.2h-1.6c-.2 0-.4.1-.6.1h-.4c-.2 0-.4.1-.6.1-.1 0-.2.1-.3.1h-.4c-.2 0-.4-.1-.6-.1-.3-.1-.5-.2-.7-.4-.2-.2-.5-.3-.7-.4-.2 0-.4 0-.6.1s-.3.1-.5.1-.1-.2-.1-.3v-1c0-.1.1-1.1.3-1.1v.2c0 .1.1.1.1.2l.1-.2c0-.2.1-.3.1-.5s.1-.4 0-.6c0-.1 0-.2-.1-.2h-.1c-.1 0-.2-.1-.2-.2 0-.2 0-.3.1-.4s.1-.3.2-.4c.5.5.5.4.5.4Z",
    style: {
      fill: "#070d18"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.9 1358.7c-.7.7-1.5 1.3-2.4 1.7-.1-.1-.3-.1-.4-.1s-.3 0-.3-.1c-.1-.1.1-.1.2-.1s.2 0 .2-.1c.1-.2-.6-.2-.7-.3-.2 0-.4-.1-.6 0-.1 0-.2 0-.4-.1-.1 0-.2 0-.3-.1-.2-.1-.4-.1-.7-.1 0 0-.3 0-.3-.1.1 0 .2-.1.4-.1h.3c.5.1 1.1.2 1.6.1h.4c.2 0 .4 0 .5-.1.2 0 .3-.1.5-.1 0 0 .2 0 .2-.1h-1.2c-.1 0-.2 0-.3-.1 0-.1.2-.1.2-.1.1 0 .3 0 .4-.1.4-.1.7-.1 1.1-.1h1.4q.1.1.2.1Z",
    style: {
      fill: "#070d18"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.8 1351.4c0 .1-.1.3 0 .4 0 .1.1.1.1.1.2.1.3.1.5.1.1 0 .3-.1.4-.1.1-.1.1-.2.2-.3v-.2q0-.1-.1-.1t-.1-.1H89c0 .2-.1.2-.2.2Z",
    style: {
      fill: "#223648"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.1 1351.9s.1-.1.2-.1c0 0 .1 0 .1.1v.2h-.2c0-.1 0-.2-.1-.2Z",
    style: {
      fill: "#223648"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.7 1352.2c.1 0 .1-.1.2-.1h.3l.1.1v.2q0 .1-.1.2c-.1.1-.2.1-.2.2-.1 0-.2.1-.3.1s-.1 0-.2-.1h-.2c-.1 0-.2-.1-.2-.2s.1-.1.1-.1.1-.1.2-.1h.1c.1-.1.1-.2.2-.2Z",
    style: {
      fill: "#223648"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.6 1352c0 .1-.1.1-.1.2s.1 0 .1-.2Z",
    style: {
      fill: "#223648"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.4 1353.6c-.3 0-.5-.1-.8-.1s-.6.1-.8.3c-.1.1-.2.2-.2.3v.1l.1.1c.1.1.3.1.4.2.1 0 .3.1.4.1h.4c.1 0 .3 0 .4-.1.1 0 .2-.1.3-.2 0-.1.1-.1.1-.2v-.2q0-.1-.1-.2l-.1-.1h-.1Z",
    style: {
      fill: "#223648"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92 1353.6c0 .1.1.1.1.2h.3q.1 0 .1-.1c0-.1-.1-.1-.2-.1 0 0-.1-.1-.3 0Z",
    style: {
      fill: "#223648"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.8 1354.7h.6q.1 0 .1.1v.1l-.1.1c-.1 0-.2.1-.2.1-.2.1-.3.1-.5.1h-.1l-.1-.1v-.2l.1-.1.2-.1q-.1 0 0 0Z",
    style: {
      fill: "#223648"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.5 1354.3v.6s0 .1.1.1h.2c.1 0 .2-.1.3-.1s.1-.1.1-.2c.1-.1.1-.2.1-.3v-.4c0-.1-.1-.2-.1-.3s0-.1-.1-.1h-.2c-.1 0-.2.1-.3.1s-.1.1-.1.1q0 .1-.1.2v.2c.1-.1.1 0 .1.1Z",
    style: {
      fill: "#223648"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.9 1353.2c0-.1-.1-.2 0-.2s.1.1 0 .2c.2 0 .1 0 0 0Z",
    style: {
      fill: "#223648"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.1 1352.6c0-.2-.1-.4 0-.6 0-.1.1-.1.2-.1l.1.1c0 .1.1.1.1.2v.4s0 .1-.1.1l-.1.1h-.2q.1-.1 0-.2Z",
    style: {
      fill: "#223648"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86 1351.6q0 .1.1.2h.1s.1 0 .1-.1v-.2l-.1-.1c-.2 0-.2.1-.2.2Z",
    style: {
      fill: "#223648"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.9 1354.6c.1 0 .2-.1.3-.1h.2c.1 0 .3-.1.4-.1h.4c.2 0 .3-.1.5-.1h.6c.3 0 .7.1 1 .2.1 0 .2 0 .2.1h.3c.1 0 .1-.1 0-.2s-.2-.1-.3-.1h-.2c-.1 0-.2 0-.2.2v.2c0 .1-.1.2-.2.2 0 0-.1 0-.1.1 0 0-.1 0-.1.1-.1 0-.1.1-.2.1 0 0-.1 0-.1.1-.1.1-.3.1-.4.1s-.2.1-.3.1-.1 0-.2.1h-.2c-.2.1-.4.1-.6.1q-.1 0-.2-.1c0-.1-.1-.1-.1-.2s-.1-.2-.1-.2c-.1 0-.2-.1-.3-.1l-.1-.1v-.2c-.1-.1-.1-.2 0-.2Z",
    style: {
      fill: "#223648"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.8 1354.2q.1 0 .2-.1h.2v.1h-.4q.1 0 0 0Z",
    style: {
      fill: "#223648"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.9 1357.8c-.2 0-.4 0-.6.1-.1 0-.1.1-.2.2s.1.2.2.2c.2 0 .4.1.6.2s.3.1.5.1c.1 0 .2-.1.3-.2v-.2q0-.1-.1-.1c-.1-.1-.2-.2-.4-.2 0-.2-.2-.2-.3-.1Z",
    style: {
      fill: "#223648"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.6 1357.5s-.1 0 0 0l.3.1s.1 0 .1-.1v-.2c0-.1 0 0 0 0h-.2c-.1 0-.2.2-.2.2Z",
    style: {
      fill: "#223648"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.7 1358.3h.3c.1 0 .2 0 .2.1h.2v.1c0 .2-.2.2-.4.2h-.3c-.1 0-.2 0-.4-.1-.1 0-.2 0-.3-.1h-.1l-.1-.1v-.3h.1c.1-.1.3-.1.4 0h.2c.1.1.1.2.2.2Z",
    style: {
      fill: "#223648"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.1 1349.9c-.1 0-.2.1-.3.1h-1.2c-.1 0-.2-.1-.3-.1H91c-.1 0-.2 0-.3-.1h-.1v-.1h.1c.1 0 .2.1.3.1.1.1.3 0 .5.1h.2s.1 0 .1.1h.2c.1 0 .2-.1.4-.1.1-.1.3-.1.4-.1l.3.1c.1-.1.2-.1.2 0l.1.1c-.2-.2-.3-.2-.3-.1Z",
    style: {
      fill: "#070d18"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.6 1347.6h.2-.2c.1 0 0 0 0 0h-.2c.1-.1.2 0 .2 0Z",
    style: {
      fill: "#070d18"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.2 1347c-.1.1-.1.2-.2.3-.1.1-.2.2-.3.2-.1.1-.3.1-.4.2-.1 0-.3.1-.5.1h-.3c-.1 0-.3 0-.4-.1h-.3c-.1 0-.2-.1-.3-.1H93h1.7v-.1s-.2-.1-.2-.2h1.3c.1 0 .1-.1.2-.1l.1-.1s0-.1.1-.1c-.3-.2-.2-.1 0 0 0 0-.1 0 0 0Z",
    style: {
      fill: "#070d18"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m96.2 1347.4-.3.3c-.1.1-.2.1-.4.2-.1 0-.2.1-.3.1H95v.1h.3c.2 0 .3 0 .5-.1.1 0 .2-.1.3-.1l.3-.3c0-.1.1-.2 0-.2q-.1-.1-.2 0c0-.1-.1-.1 0 0Z",
    style: {
      fill: "#070d18"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.6 1349.1c-.2 0-.3-.1-.5-.1 0 0-.3-.2-.1-.2 0 0-.1-.1-.1-.2l-.1-.1s-.1-.1-.2-.1-.1-.1-.2-.1c-.2-.1-.4-.1-.5-.1s-.3.1-.4.2c-.2.1-.3.2-.5.2-.3.1-.6.2-1 .2-.2 0-.4 0-.6.1h-1.1c-.1 0-.3 0-.3-.1.1 0 .2-.1.3-.1h.5c.4-.1.9-.1 1.3-.3.2 0 .4-.1.6-.2.1 0 .2 0 .3-.1.1 0 .2-.1.3-.1s.3-.1.4-.2c0 0 .1 0 .1-.1.1-.1-.1-.2-.2-.2s-.2-.1-.2-.1c-.1 0-.3-.1-.4-.1-.2-.1-.3-.1-.5-.1l-.4-.1c-.1 0-.2 0-.3-.1 0 0-.1 0-.1-.1h.1c0-.1-.4-.1-.4-.1h-2.1c0-.1.2-.1.3-.1 0-.1-.4-.1-.4-.1h-1.3c0-.1.1-.1.1-.2.2-.1.3-.2.5-.2v-.1c1.5-.3 3.1-.1 4.6.6.1.1.3.2.4.2.7.6 1.4 1.3 2.1 2.2Z",
    style: {
      fill: "#1e3a4a"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M100 1353.5v.5c0 .6-.2 1.3-.4 1.9v-1.9c0-.2 0-.4-.1-.6v-1.2c0-.1-.1-.2-.1-.2-.1-.1-.1-.3-.1-.5 0-.1-.1-.3-.1-.4-.1-.1-.1-.3-.3-.4-.1-.1 0-.1 0-.2s-.1-.1-.1-.1c-.1 0-.1-.1-.2-.1s-.1.1-.2 0c0 0 .1-.1.2-.1 0 0 .2 0 .2-.1s-.1-.1-.1-.2c0 0 0-.1-.1-.1 0 0-.1 0-.1-.1l-.1-.1s0-.1-.1-.1l-.2-.2c-.1-.1-.3-.1-.4-.2q-.1 0-.2-.1l-.1-.1v-.2s0-.1.1-.1v-.1c0-.1-.1-.3-.2-.4s-.2-.1-.3-.1h-1.1c0-.1.1-.1.2-.1s.2-.1.3-.2c.1 0 .1-.1.2-.2l.1-.1c-.1-.1-.2-.1-.3-.2-.1-.1-.2-.1-.4-.1-.1 0-.2-.1-.3-.1s-.3-.1-.4-.2-.2-.2-.3-.2-.2-.1-.3-.1h-1c-.2 0-.3-.2-.4-.3q-.1-.1-.2-.1c-.1 0-.2-.1-.4-.1h-.8c-.1 0-.2.1-.4.1h-.4c-.1 0 .1-.2-.1-.2s-.4.1-.6.1-.4.1-.6.2c-.1 0-.2.1-.4.2s-.4.2-.6.2c.7-.3 1.4-.6 2.1-.7 1.5-.3 3.1-.1 4.6.6.1.1.3.2.4.2.9.5 1.7 1.2 2.3 2.1.2.3.4.5.5.8.2.4.4.8.5 1.2v.2c.2.5.3 1 .3 1.5v.4c.5.3.5.5.5.6Z",
    style: {
      fill: "url(#t)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 1353.1v-.4l-.3-1.5v-.2c-.1-.4-.3-.8-.5-1.2-.2-.3-.3-.6-.5-.8-.6-.8-1.4-1.5-2.3-2.1-.1-.1-.3-.2-.4-.2-1.5-.7-3.2-.9-4.8-.6-1.6.3-3.1 1.2-4.1 2.4 0 .1-.1.1-.1.2.6-.7 1.4-1.3 2.2-1.7.7-.4 1.4-.6 2.1-.7 1.5-.3 3.1 0 4.6.6.1.1.3.1.4.2.9.5 1.7 1.2 2.3 2.1.2.3.4.5.5.8.2.4.4.8.5 1.2v.2c.2.5.3 1 .3 1.5v1.3c0 .6-.2 1.2-.4 1.8-.3.8-.6 1.5-1.1 2.1l-.2.2c.1-.1.2-.3.4-.4.5-.6.9-1.4 1.1-2.1.2-.6.3-1.2.4-1.8v-.5c-.1-.1-.1-.3-.1-.4Z",
    style: {
      fill: "url(#u)",
      isolation: "isolate",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1 1351.8h.3v-.1h-.1s-.1 0-.2.1ZM93 1348.3h.3v-.1h-.1s-.1 0-.2.1ZM91.9 1358.8h.3v-.1h-.1c-.1 0-.2 0-.2.1ZM86.7 1353.1h.3v-.1h-.1s-.1 0-.2.1Z",
    style: {
      fill: "#4f85aa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97 1356.1c0-.1.1-.1.2-.2 0 0 .1 0 .1.1v.2c0 .1-.1.1-.2.2s-.2.1-.2.1h-.2v-.2l.1-.1s.1 0 .2-.1Z",
    style: {
      fill: "#101d28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m97.7 1356-.2.2h.2c0-.1.1-.1 0-.2ZM96.4 1353.4l-.2.2h.2c0-.1.1-.2 0-.2ZM90.2 1346.7l-.2.2h.2c.1-.1.1-.2 0-.2Z",
    style: {
      fill: "#4f85aa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1 1354v.3s.1 0 .1.1.1.1.1.1.1 0 .1-.1v-.2c0-.1-.1-.2-.1-.2h-.2q.1 0 0 0ZM90.2 1349.5q.1.1 0 0 .1 0 0 0 .1 0 0 0 .1 0 0 0ZM90.3 1349.8v.2s.1 0 .1.1c0 0 .1.1.1 0 0 0 .1 0 .1-.1v-.2c0-.1-.1-.2-.1-.2h-.1q-.1.1-.1.2Z",
    style: {
      fill: "#101d28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7 1348.8h.3s.1 0 .1-.1c.1 0 .1-.1.2-.1-.1 0-.5 0-.6.2Z",
    style: {
      fill: "#4f85aa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1 1351.1h.3l.1-.1c.1 0 .1-.1.2-.1v-.1c-.1-.1-.5 0-.6.3Z",
    style: {
      fill: "#101d28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3 1353.6s.1.2 0 0c.1 0 .1-.1 0 0q0-.1 0 0ZM87.5 1353.9s0-.1 0 0q0-.1 0 0c.1-.1.1 0 0 0 .1 0 .1.1 0 0q.1.1 0 0 0 .1 0 0Z",
    style: {
      fill: "#223f51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8 1358.2c.1.1.1.2.2.2q.1.1.1.2c.1.1.2.1.3.2 0 0 .1 0 0 0 0-.1-.1-.1-.2-.2s-.2-.1-.2-.2-.1-.2-.2-.2ZM87.9 1358.1c0-.1-.1-.1-.1-.2q.1.1.1.2ZM97.3 1355.7s.1-.1 0 0ZM87.9 1351.9s.1-.1 0 0c.1.1 0 .1 0 0Z",
    style: {
      fill: "#4f85aa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 1354.2s.1-.1.2-.1h.1l.1.1q0 .1-.1.2c-.1-.1-.3 0-.3-.2Z",
    style: {
      fill: "#223f51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.8 1349.6s.1-.1.2-.1h.1l.1.1q0 .1-.1.2c-.1-.1-.3-.1-.3-.2Z",
    style: {
      fill: "#4f7896"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7 1359.8c0-.1.1-.1.2-.2 0 0 .1 0 .1-.1v.1c0 .1-.1.1-.3.2.1.1 0 .1 0 0Z",
    style: {
      fill: "#4f85aa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#v)"
    },
    "data-name": "startup_plamet_2"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87 867.6c0 4.7-1.4 9.3-4 13.3s-6.3 7.1-10.6 9c-4.3 1.9-9.1 2.5-13.8 1.8-4.7-.8-9.1-2.8-12.6-6s-6-7.3-7.2-11.9c-1.2-4.6-1.1-9.4.4-13.9s4.3-8.4 8-11.4c3.7-2.9 8.2-4.8 12.9-5.2.8-.1 1.6-.1 2.4-.1 2.8 0 5.5.5 8.1 1.4.8.3 1.5.6 2.3.9 4.2 2 7.8 5.1 10.3 9 2.5 4 3.8 8.5 3.8 13.1Z",
    style: {
      fill: "url(#w)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.9 845.5c-.1.1-.2.1-.2.2-.1.1-.2.1-.3.2-.1.1-.2.2-.2.4-.2.4-.4.8-.5 1.2 0 .3-.1.9.1 1.2.3.5.8.7 1.3.8.2.1.5.2.7.2.3.1.6.1.9.1.4.1.8.1 1.2.3.2.1.4.1.5.2.1.1.3.1.4.2.7.1 1.4.1 2.1.4.4.2.9.3 1.4.6.1.1.2.2.3.2.1.1.2.1.3.2.2.1.4.3.6.4.1.1.3.3.3.5.1.2.2.3.3.4.2.3.3.7.4 1 0 .2.1.5-.1.6-.1.1-.3.2-.4.3-.2.1-.5.2-.8.2-.2 0-.3-.1-.5-.1s-.3 0-.5-.1c-.4-.1-.8-.3-1-.6-.3-.3-.6-.5-.9-.7-.4-.3-1-.5-1.5-.5-.3 0-.4.1-.6.3-.2.1-.6 0-.8-.1-.3-.1-.6-.2-.9-.1-.3.2-.5.5-.8.5-.5 0-.9.1-1.4.2-.2 0-.4.1-.6.3-.1.1-.2.2-.4.3-.1.1-.2.3-.4.4-.2.1-.4.2-.5.4-.3.3-.7.5-1.1.8-.3.1-.6.3-.9.4-.4.2-.9.2-1.4.4-.4.2-.8.6-1.1.9-.3.3-.6.5-.9.8-.2.2-.3.5-.4.7-.3.8 0 1.6-.3 2.3-.1.2-.2.3-.2.5-.1.2-.2.5-.3.7-.2.4-.5.7-.9.9-.2.1-.5.1-.7.2-.1 0-.2.1-.3.1s-.2.1-.3.1c-.4.1-.5.5-.6.9-.1.3-.3.6-.2.9.1.5.9.7 1.3.9.2.1.3.2.2.5 0 .2-.1.4-.2.5s-.4 0-.5.1 0 .2 0 .3 0 .3.1.4c.1.2.1.4 0 .7s-.2.7-.3 1c-.1.4.3.7.6.9.2.1.5.3.7.4.2.1.4.2.7.2.2 0 .4.1.6.1.3.1.5.2.8.4.2.1.4.1.6.2.3.1.6.3.9.4.2 0 .4.1.5.2l.3.3c.3.2.5-.4.2-.6-.3-.2-.6-.2-.9-.4-.2-.2-.4-.5-.6-.7l-.6-.9c-.1-.3-.1-.6-.1-.9s0-.6-.1-.9c-.1-.2-.3-.4-.4-.7-.1-.2-.1-.4-.1-.6s0-.4-.1-.6c-.1-.1-.1-.2-.1-.3s0-.2.1-.3c.2-.3.4-.6.7-.8.4-.3.8-.6 1.3-.9.5-.3 1.1-.4 1.6-.6 1.3-.4 2.6-.8 3.9-.3.9.3 1.7.5 2.6.7.3 0 .5 0 .8-.1s.5-.2.8-.2c.3.1.7.2 1.1.2.3 0 .6-.1 1-.1.3.1.5.2.7.3.3.1.3.3.5.5.1.2.2.3.3.5l.3.3c.2.2.3.5.4.8s.1.8 0 1.1c0 .5-.1.9-.1 1.4-.1.4-.2.8-.3 1.1-.1.4-.1.8-.1 1.2.1.4.2.8.1 1.3-.1.4-.2.8-.3 1.1-.2.4-.3.8-.5 1.1-.2.4-.5.7-.8 1.1-.2.4-.5.7-.8.9-.2.1-.3.3-.4.4-.1.2-.1.3-.2.5 0 .1 0 .2-.1.3-.1.2-.1.3-.2.4-.1.2-.1.4-.3.5-.1.1-.2.1-.3.2-.2.1-.4.3-.6.4-.2.2-.3.4-.5.5-.2.2-.4.3-.6.5-.4.3-.7.7-1.2 1-.4.2-.7.4-1.1.5s-.8.3-1.2.5c-.3.1-.7.2-1.1.3s-.7.3-1 .4c-.3.2-.6.3-.9.4-.3.1-.6.1-.9.2-.6.2-1.1.5-1.8.5-.2 0-.5.1-.7.1h-1c-.4.1-.7.1-1.1.2-.4 0-.6.1-1 .1-.2 0-.5-.1-.7-.1-.1-.1-.3-.2-.4-.3-.3-.2-.5-.5-.9-.6s-.8 0-1.2-.1c-.4 0-.9-.2-1.3-.3-.2-.1-.4-.1-.6-.2h-.7c-.5 0-1.1.2-1.6.2-.4.1-.9.2-1.3.2-.3 0-.7-.1-1-.2-.4-.1-.7-.3-1-.4-.4-.1-.9-.2-1.3-.3-.3-.1-.7-.1-1-.2l-.9-.3c-.2-.1-.5-.3-.7-.4-.2-.1-.5-.2-.7-.2-.1 0-.2.1-.4.1-.1 0-.3 0-.4-.1-.3-.1-.5-.3-.7-.6q-.1-.1-.1-.2v-.3c.1-.5.3-1-.1-1.5-.2-.3-.5-.4-.8-.5s-.6 0-.9.1c-.3 0-.5 0-.8-.1l-.6-.3c-.2-.1-.3-.2-.5-.3 1.8 3.4 4.4 6.4 7.6 8.6 3.2 2.2 6.9 3.7 10.7 4.2 3.9.5 7.8.1 11.4-1.1 3.7-1.3 7-3.4 9.7-6.2s4.7-6.2 5.8-9.9c1.1-3.7 1.3-7.6.6-11.4-.7-3.8-2.3-7.4-4.7-10.4-2.4-2.5-5.5-4.9-9-6.6Zm1.2 39.2c-.1.4-.4.9-.8 1.2-.4.4-.8.7-1.2 1-.2.1-.4.3-.7.4-.2.1-.5.2-.7.3-.4.1-.8.1-1.2.2-.4.1-.8.1-1.2.1-.3 0-.6-.1-.9-.3-.2-.2-.3-.3-.4-.6-.1-.2-.1-.5 0-.7 0-.1.1-.3.1-.4.4-.4.8-.8 1.2-1.1l.6-.3c.2-.1.4-.1.5-.2.4-.2.8-.4 1.3-.5.2-.1.5-.1.7-.1.2-.1.5-.1.8-.1h.5c.2 0 .3 0 .5.1.3.1.6.2.7.4.2.1.2.4.2.6Z",
    style: {
      fill: "#190024"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.1 866.4c.1-.1.2-.3.3-.5.1-.1 0-.2-.1-.2-.2-.1-.5 0-.7.1-.3.1-.6.1-.9.1h-.9c-.2 0-.5 0-.7.1-.5.1-1.1.4-1.3.8-.2.3-.4.7-.5 1.1-.1.3-.1.5-.1.8 0 .2.1.4.2.6.1.4.3.8.6 1.1.1.2.3.4.5.5l.3.3c.2.2.5.3.8.4.1 0 .2 0 .3.1.1.1.1.2.2.3.1.2.2.4.3.7 0 .2 0 .5-.1.7-.1.5-.5.8-.9 1.1s-.8.4-1.3.3c-.3 0-.6-.1-.9-.1-.2-.1-.4-.1-.7 0-.5.1-1.1.1-1.6 0-.6-.1-1.2-.5-1.7-.9l-.6-.6c-.2-.1-.4-.1-.5-.2-.2-.1-.4-.3-.6-.4-.3-.2-.5-.3-.7-.6-.3-.4-.4-.9-.4-1.3 0-.5 0-1.1-.2-1.6-.1-.1-.1-.3-.1-.4 0-.2.1-.4.3-.6.2-.3.2-.6.4-.9.1-.1.1-.3.2-.4 0-.2 0-.3-.1-.4 0-.1-.1-.2-.1-.2 0-.1-.1-.1-.1-.2v-.4c.1-.4.2-.8.5-1.1.2-.3.4-.5.7-.6.2-.1.4-.1.7-.2.4-.2.8-.3 1.1-.6l.6-.6.3-.3c.1-.1.1-.2.2-.3l.3-.6c.1-.2.1-.5.1-.7 0-.3.1-.6.1-.9.2-.1.3-.3.4-.4.2-.2.4-.5.6-.7.5-.8.9-1.6 1.3-2.4.2-.5.4-1 .7-1.4.2-.3.4-.7.4-1.1.1-.6 0-1.1-.2-1.6-.1-.4-.3-.5-.6-.8-.2-.2-.4-.4-.5-.7-.1-.1-.1-.2-.1-.3v-.4c-.1-.4-.1-.8-.2-1.1-.1-.2-.1-.4-.2-.5-.1-.3-.3-.5-.4-.7-.3-.3-.6-.5-1-.7l-.9-.6c-.4-.2-.9-.2-1.4-.2s-1.1 0-1.6-.1c-.6 0-1.1 0-1.7-.1-.4 0-.8 0-1.2.1-.5.1-1 .2-1.5.4s-1 .3-1.5.5c-.3.1-.5.2-.8.3-.2.1-.5.1-.7.2-.4.1-.8.2-1.1.4-.8.3-1.6.4-2.4.7-.6.2-1.2.5-1.7.9-.2.2-.4.3-.5.5-.3.2-.5.5-.7.7l-.3.6c-.1.3-.2.6-.2.9-.2.6-.2 1.3-.2 2s-.1 1.3-.1 1.9c0 .5-.1 1.1-.3 1.6-.1.4-.3.8-.5 1.1-.5 1-1 2-1.1 3.2 0 .9.2 1.8.9 2.5.4.4.8.6 1.1 1.1.2.4.3.8.3 1.2s.1.7.3 1.1c.2.4.5.7.9.9.4.3.9.6 1.3.9.3.3.6.6 1 .9.3.2.6.4 1 .5s.7.2 1.1.4l.9.6c.2.2.5.3.8.5s.6.4.7.7l.3.9c.1.4.3.7.5 1s.4.5.6.7c.3.3.6.4.9.7l.9.9c.8.7 1.6 1.4 2.6 1.8 1 .4 2.2.4 3.2.3 1.2 0 2.4-.2 3.6-.5 1-.2 1.9-.6 2.8-1.1.7-.4 1.5-1.2 1.5-2.1 0-.3-.1-.6-.1-.8v-.8c0-.6-.2-1.1-.5-1.5-.1-.2-.2-.3-.2-.5-.1-.2-.2-.3-.4-.5-.3-.3-.6-.5-1-.6-.2 0-.3-.1-.4-.2-.1-.1-.2-.2-.3-.4-.2-.4-.2-.8-.3-1.2 0-.3-.1-.7.3-.9s1-.1 1.3.1c.2.1.2.4.3.6.2.6 1.5.3 1.7-.1.1-.2.1-.5.2-.7 0-.3 0-.6-.1-.8-.1-.1 0-.2 0-.3-.8-.5-.8-.6-.7-.8Zm-13.9 2.5c.1-.1.2-.1.4-.1s.3.1.4.2c.1.1.2.3.3.5.1.1.1.3.2.4.1.2.2.4.1.6 0 .1 0 .2-.2.3-.1.1-.3.2-.4.2h-.3c-.1 0-.2-.1-.3-.2-.1 0-.1-.1-.2-.1v-.2c-.2-.1-.3-.3-.5-.5-.1-.1-.1-.3-.1-.4 0-.2.1-.3.2-.5.1 0 .2-.2.4-.2Zm4.9 8.1c-.2.6-.5 1.3-1.2 1.4h-.7c-.7-.1-1.3-.3-1.8-.7-.2-.1-.4-.3-.6-.5s-.4-.3-.6-.5c-.3-.2-.6-.6-.9-.7-.2-.1-.3-.3-.5-.4-.1-.1-.3-.2-.4-.3l-.3-.3c0-.1-.1-.1-.2-.2q0-.1-.1-.1c-.1-.1-.2-.3-.2-.4s-.1-.2-.1-.3 0-.3-.1-.4c0-.1 0-.2-.1-.3 0-.1-.2-.4-.2-.5.1 0 .1-.1.1-.3 0-.1.1-.2.1-.2v-.1s0-.1.1-.1v-.1c.1-.2.3-.4.6-.5.2-.1.4-.1.6-.2.3-.1.6-.1.9 0s.5.1.8.2c.2.1.5.2.7.3.4.2.7.5 1.1.7.2.2.5.4.7.5s.3.2.5.3c.3.3.6.6.8 1 .1.2.2.5.3.8.1.2.1.4.2.6.4.5.6.9.5 1.3Z",
    style: {
      fill: "#190024"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.7 850.7c-.1.3-.2.7-.3 1v.4c0 .2-.1.5 0 .7v.7c0 .3-.1.6-.1.9s0 .5-.1.8c0 .2-.1.5-.1.7-.1.2-.1.4-.2.6v.2c0 .1-.1.1-.1.2.3.2.4-1.1.8-1.1v.6c0 .3-.1.5-.1.8 0 .4 0 .7.1 1.1 0 .5.1 1 .2 1.4.1.5.1 1.1.2 1.6 0 .2.1.6.3.8q.1.1.2 0t.2-.1c.1 0 .1-.1.2-.1s.2 0 .3.1c.1-.1 0-.1 0-.2 0-.3.1-.5.1-.8 0-.5.1-1 .2-1.6 0-.3.1-.9.3-1.2.1-.1.2-.1.3 0 0 .1.1.2 0 .3 0 .1.1.3.1.4.1.3.1.5.3.8 0 .1.1.5.2.5s.3-.3.3-.4c.1 0 .6.5.7.7.1.1.1.2.1.3.1.1.2.2.2.3.1.2.2.6.4.8.4.4.7-.2 1-.5.2-.3.3-.5.5-.8.1-.2.2-.3.3-.5 0-.1.1-.3.2-.3s.4.4.5.5.2.3.3.4c.2.1.5-.1.6-.1.8-.4 1.4-.9 1.8-1.6.5-.7 1-1.5 1.7-1.9.2-.1.4-.3.6-.5.3-.3.6-.7.8-1.1.3-.5.5-1 .8-1.5.3-.6.7-1.2 1.1-1.8.5-.9 1.2-1.6 1.3-2.7.1-.9.2-2-.4-2.8-.3-.4-.8-.5-1.2-.6-.3 0-.7 0-1 .1-.4.1-.7.2-1.1.4-.6.3-1.1.6-1.8.5-.3 0-.5-.3-.7-.4-.2-.1-.5-.2-.8-.1-.8.1-1.4.6-2.1 1.1-.4.3-.8.6-1.1.9-.1.1-.2.2-.4.3-.2.2-.4.5-.6.7-.2.2-1.8 1.8-1.8.9 0-.3.2-.6.3-.9.1-.1.1-.3.1-.5-.1 0-.2-.1-.3-.1-.2 0-.3.1-.4.1-.1.1-.2.1-.3.2-.1.1-.2.2-.2.3-.1.4-.4.7-.7 1l-.4.4q-.1.1-.2 0c-.1-.1-.1-.5-.2-.6 0-.1-.1-.1-.1-.1l-.1-.1c-.2 0-.3.1-.4.2 0 .2-.2.3-.3.3Z",
    style: {
      fill: "#5a4862"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.8 863.2c.1.5.2 1 .4 1.5.1.3.3.6.4.9.1.2.2.4.4.5.1.1.2.2.3.4s.3.3.4.5c.1.1.2.3.4.3.1.1.2.1.2-.1s0-.5-.1-.7-.2-.5-.4-.8c-.1-.2-.2-.4-.3-.7s-.3-.6-.5-.9c-.2-.3-.4-.5-.7-.8-.1 0-.4-.3-.5-.1Z",
    style: {
      fill: "#5a4862"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.7 867.5c.2.4.5.7.7 1.1l.3.3v-.1c.1 0 .2.1.2.2.2.1.3.3.4.5l.5.5c.1.1.2.3.4.3.1-.1-.1-.3-.2-.4-.1-.2-.2-.4-.4-.6-.3-.4-.6-.9-.9-1.3-.2-.3-.4-.6-.7-.8h-.2s-.1 0-.1.1c0 0 0 .1-.1.1 0 0 .1.2.1.1Z",
    style: {
      fill: "#5a4862"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.3 862.3c.3-.6.5-1.2.7-1.8s.4-1.1 1-1.5c.9-.7 2-1 3-1.5.6-.2 1.1-.6 1.7-.8.7-.2 1.3-.5 2-.7.2-.1 1.2-.4 1.4-.1.1.3-.3.4-.3.6h.8c.3-.1.6-.1.9-.1h.8c.5 0 .9.2 1.4.3l.9.3c.2.1.5.1.6.3.1.1.1.2-.1.3-.1 0-.3 0-.4.1s.2.4.3.4c.6.4 1.3.3 1.9.7.2.1.5.3.7.3.2.1.5 0 .7.1.5.1 1 .7 1.2 1.1.2.4.4.8.6 1.1.3.4.3.9.5 1.4.3.9.4 1.8.6 2.8.1.9.2 1.9 0 2.8-.2.8-.2 1.5-.3 2.3-.2.8-.3 1.6-.4 2.4 0 .3 0 .7-.1 1-.1.4-.1.8-.2 1.2s-.2.8-.4 1.2c-.1.2-.1.5-.3.7-.1.3-.4.7-.7.8-.1 0-.3-.1-.4-.2-.2-.1-.3-.2-.4-.3l-.3-.3c-.1-.1-.1-.2-.1-.4v-.3c0-.1-.1-.3 0-.4 0-.2.1-.5 0-.7 0-.1.1-.3.1-.4v-.7c.1-.5 0-.9-.1-1.4 0-.2 0-.4-.2-.4-.1.1-.1.2-.2.3 0 .1-.1.3-.1.5 0 .3 0 .6-.1.9 0 .2-.1.4-.1.6-.1.2-.2.5-.3.7-.2.4-.3.9-.5 1.3-.4.9-1 1.6-1.6 2.3l-.9.9c-.3.3-.7.6-1.1.8-.9.5-1.7 1.1-2.5 1.8-.5.4-1 .8-1.5 1.1-.3.1-.4-.1-.1-.3.3-.3.8-.4 1.1-.7.6-.5 1.1-1 1.7-1.5.8-.7 1.5-1.4 2.3-2.2l.6-.9c.2-.3.4-.5.6-.8.2-.5.4-1 .5-1.5l.3-1.2v-.6c0-.1 0-.3-.1-.4-.1 0-.1.3-.2.4-.1.3-.1.5-.2.8 0 .1-.2.4-.3.4s-.1-.4-.1-.5c.1-.3.1-.5.2-.8s.1-.7.2-1 .1-.6.1-.9.1-.6.2-.9c.1-.4.1-.7.2-1.1.1-.5.2-1 .3-1.4.1-.5.2-1 .3-1.4.1-.6 0-1.1.2-1.7 0-.2.2-.6.4-.5.3.1.3.6.5.8.2.3.3.6.5.8s.2.4.5.4c.4-.1.7-.7.7-1 0-.2 0-.4-.1-.6v-.3c0-.1-.1-.2-.1-.3 0-.5-.1-1-.3-1.5l-.3-.9c-.2-.4-.5-.8-.9-1.1-.7-.6-1.5-1-2.4-1.1-.3-.1-.6-.1-.8 0-.2.1-.5.2-.5.4s.3.5.4.7c.3.3.6.5 1 .8.4.2.8.5 1.1.8.2.3.3.6.3.9 0 .1 0 .5-.1.6s-.5.1-.6 0c-.3-.1-.6-.3-.8-.6-.3-.2-.6-.5-.9-.6-.3-.2-.7-.4-1.1-.5s-.8-.2-1.2-.2c-.3 0-2.7-.2-2.6.1.3.1.6.1 1 .1.3 0 .7.1 1 .3.2.1.2.2 0 .2-.3 0-.5 0-.8.1h-.6c-.2 0-.5.1-.7.1-.5 0-1 0-1.4-.1-.5-.1-.9-.1-1.4-.2-.4 0-.8-.1-1.2-.1s-.8-.1-1.2-.1c-.5 0-1 0-1.4.2-1 .3-1.9.9-2.8 1.3-.4.2-.8.4-1.2.7l-.9.6c-.3.2-.5.5-.8.7-.1.1-.2.2-.2.3s-.1.2-.1.3c-.1-.3 0-.7.2-.9.2-.4.5-.6.9-.8.8-.4 1.5-.8 2.2-1.2l.3-.3c.1-.1.1-.2.2-.4v-.2c.2-.5.3-.8.2-.9Z",
    style: {
      fill: "#5a4862"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69 848.1c0-.1.1-.2.2-.2h.6c.1 0 .2.1.2.2.1 0 .1.1.2.1.1.1.1.2.2.2 0 .1.1.3.1.4v.4c-.1.1-.2.3-.4.3-.1.1-.3.1-.4 0-.2 0-.5 0-.4-.3.1-.2.3-.1.4-.1s.1-.1.2-.1h.1s.1 0 .1-.1v-.2q-.1-.1-.2-.1h-.3s-.1 0-.1-.1l-.1-.1-.1-.1c-.3-.1-.3-.2-.3-.2Z",
    style: {
      fill: "#43dff6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.6 847.5v-.6c0-.1.1-.3.1-.4.1-.2.1-.5 0-.8 0-.1-.1-.4.1-.4q.1 0 .2.1c.1 0 .1.1.1.1q.1.1.1.2c0 .1.1.1.1.2v.7c0 .1-.1.3-.1.4s-.1.2-.1.3c-.1.1-.1.2-.2.2 0-.1-.2 0-.3 0Z",
    style: {
      fill: "#43dff6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.5 843c.1.1 0 .2 0 0Z",
    style: {
      fill: "#43dff6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.6 844.6c-.1.3-.3.5-.5.8s-.4.5-.7.7c-.1.1-.3.2-.4.3s-.3.2-.5.3c-.9.3-1.8.6-2.7.3-.5-.2-1-.4-1.5-.8-.2-.2-.4-.3-.6-.5s-.4-.4-.7-.5c-.4-.3-.9-.3-1.4-.5-.2-.1-.4-.1-.5-.2-.2-.1-.3-.2-.5-.3-.1-.1-.2-.2-.3-.4-.1-.1-.2-.2-.2-.3l-.1-.1c.8-.1 1.6-.1 2.4-.1 2.9 0 5.6.4 8.2 1.3Z",
    style: {
      fill: "#43dff6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.1 850.6c.1.1.2.1.3.2h.1c.1 0 .3 0 .4.1.3.1.6.2.9.2.1 0 .3 0 .4.1.2 0 .3.1.5.1.1 0 .3.1.4.2.2.1.3.1.4.2.2.2.3.4.5.5.2.2.5.4.7.6.1.1.2.2.2.4.1.1.1.2.2.3s.2.3.2.5q0 .1-.1.1c-.1 0-.2 0-.4-.1-.2 0-.3-.1-.5-.1h-.8c-.1 0-.3-.1-.4-.1-.1-.1-.2-.1-.3-.2-.1-.1-.2-.1-.2-.2s-.1-.2-.1-.3c0-.2.1-.4 0-.5-.1-.2-.3-.3-.5-.4-.3-.1-.6-.3-.9-.4-.1 0-.1-.1-.2-.1s-.2-.1-.3-.1c-.1-.1-.2-.1-.3-.2l-.3-.3q-.1-.1-.1-.2c.1-.1.2-.2.2-.3Z",
    style: {
      fill: "#43dff6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.1 851.7h-.3s0 .1-.1.1q-.1.1-.1.2t.1.2c0 .1.1.1.1.1.2.1.5.3.7.1.1-.1 0-.2 0-.3 0 0 0-.1-.1-.1l-.1-.1c0-.1-.1-.1-.2-.1q.1-.1 0-.1Z",
    style: {
      fill: "#43dff6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.7 867.2c-.1.5-.2.9-.4 1.4-.1.3-.2.5-.1.8 0 .4-.2.7-.2 1-.1.4.1.8.3 1.1.2.4.5.7.9 1 .5.3 1 .4 1.5.6.4.1.8.2 1.2.1.5-.1 1-.4 1.4-.8.3-.3.7-.7.9-1 .2-.3.4-.7.6-1.1.3-.6.5-1.6-.2-2-.1-.1-.2-.1-.4-.1s-.3 0-.5-.1c-.2 0-.4.1-.6.1-.1 0-.2 0-.4-.1-.1-.1-.2-.1-.4-.1-.1 0-.3.1-.4.1l-.3.3c-.1.1-.1.2-.2.2s-.2-.1-.4-.1c-.2-.1-.4-.3-.6-.5-.3-.3-.6-.7-1-.8-.1-.1-.4-.1-.5 0s-.1.2-.2 0Z",
    style: {
      fill: "#43dff6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.3 867c.2.1.9.4 1.1.1v-.4c0-.1-.1-.1-.1-.1s-.1-.1-.2-.1h-.4q-.1 0-.2.1c-.1.1-.1.3-.1.5l-.1-.1Z",
    style: {
      fill: "#43dff6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m75.8 875.1.3-.6h.2s.1 0 .1.1l.1.1c.1.2.1.5.1.7v.4c0 .1 0 .2-.1.2 0 0-.1 0-.1.1h-.3c-.1 0-.2.1-.3 0-.1 0-.1-.1-.2-.1v-.4c0-.1.1-.2.2-.3 0-.1.1-.2 0-.2.1-.1 0 0 0 0Z",
    style: {
      fill: "#43dff6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.5 877.9c-.5.6-1.1 1.2-1.8 1.4-.2.1-.4.1-.6.2-.1 0-.6.2-.5.3.2 0 .3.1.4.2.1.1.2.1.3.2.1.1.2.1.2.2.2.1.3.1.5 0 .3-.1.6-.2.9-.4.1-.1.2-.2.3-.2l.3-.3c.1-.1.1-.2.2-.3 0-.1 0-.2.1-.3v-.4q0-.1-.1-.2c0-.3-.1-.3-.2-.4Z",
    style: {
      fill: "#43dff6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.4 861.8c.1.4.2.7.4 1 .2.4.4.7.7 1 .1.2.3.3.4.5.1.1.2.2.2.4.2.4.4.8.5 1.2.1.3.1.6.1.9s-.1.6-.1.8c-.1.6-.1 1.2-.2 1.8 0 .2 0 .3-.1.5 0 .2-.1.5-.1.7 0 .3-.1.7-.2 1-.1.3-.3.6-.5.9-.2.3-.4.8-.8 1-.1.1-.2.2-.3.2s-.2.1-.3.1c-.2 0-.4.1-.6 0-.2 0-.3-.1-.4-.2-.2-.1-.4-.2-.5-.3-.2-.1-.3-.3-.4-.4l-.3-.6c-.1-.2-.1-.5-.2-.7-.1-.3-.2-.5-.3-.8-.1-.5-.3-1-.3-1.5 0-.3-.1-.6-.1-.9v-1c0-.3 0-.6.1-.8v-.8c0-.6.1-1.3.2-1.9.1-.6.3-1.2.4-1.8l.3-.9c.1-.3.2-.5.4-.7q.1-.1.2-.1h.2q.1 0 .2.1c.1 0 .1.1.2.1.2.2.4.5.5.7.4 0 .5.2.7.5q-.1 0 0 0c0 .3 0 .4 0 0Z",
    style: {
      fill: "#43dff6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.7 859.8c.2 0 .4 0 .6.1q.1 0 .1.1v.1c.1.1.1.2.2.3v.2l-.1.1h-.1c-.2 0-.3-.1-.5-.2-.1-.1-.3-.4-.2-.5v-.2Z",
    style: {
      fill: "#43dff6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.2 872.7c0 .2 0 .5.1.7 0 .1.1.2.1.3.1.2.2.5.4.7.1.1.2.4.3.5.2.1.3.1.5 0 .1-.1.3-.1.5-.1q.1 0 .2-.1v-.3c0-.1-.1-.2-.2-.3-.1-.1-.2-.3-.2-.4l-.3-.3c-.2-.2-.3-.3-.5-.4-.1-.1-.3-.2-.4-.2s-.1.1-.2.1c-.1-.2-.2-.3-.3-.2Z",
    style: {
      fill: "#43dff6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m47.2 877.8.4.4c0-.1.2-.1.2-.3 0-.1-.2-.1-.2-.2-.2-.1-.6-.2-.6.1h.2Z",
    style: {
      fill: "#43dff6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m57.6 887.5.3-.6c.1 0 .3 0 .4-.1h.5c.2.1.3.2.4.3s.2.3.2.4.1.3.1.4v.1c0 .1-.1.1-.1.2-.1.1-.1.2-.2.2-.1.1-.2.1-.3.1h-.3c-.1 0-.2-.1-.4-.2-.1 0-.2-.1-.3-.2-.1-.1-.2-.3-.2-.5 0 .1 0 0-.1-.1Z",
    style: {
      fill: "#43dff6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.2 887.4h.6c0 .1.2.2.2.3s0 .1-.1.1-.2-.1-.2-.1c-.1-.1-.2-.1-.2-.2l-.3-.1Z",
    style: {
      fill: "#43dff6"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M64.9 881.2c.2 0 .5 0 .7.1-.1 0 0 .1 0 .1s0 .1-.1.1h-.4c-.1 0-.3 0-.4-.1v-.2s0-.1.2 0ZM44 868.2c.2 0 .5 0 .7.1-.1 0 0 .1 0 .1s0 .1-.1.1h-.4c-.1 0-.3 0-.4-.1v-.2c.1 0 .1-.1.2 0ZM65.3 880.6c.1.1.3.1.4.1s.2-.1.3-.1c.2-.1.3-.3.4-.4v-.3c0-.1-.1-.2-.2-.2-.2-.1-.3-.2-.5-.2h-.3c-.1 0-.2.1-.3.1-.1.1-.2.2-.2.3s0 .2.1.3c0 .2.1.3.3.4-.1-.1 0 0 0 0 .1 0 .2 0 0 0ZM63.5 877.3c.1-.1.2-.1.2-.2 0 .1.2.1.2.2s0 .1-.1.2h-.3l-.1-.1.1-.1ZM75.2 848.4c.1-.1.2-.1.2-.2 0 .1.2.1.2.2s0 .1-.1.2h-.3l-.1-.1.1-.1ZM65.4 889.5c.1-.1.2-.1.2-.2 0 .1.2.1.2.2s0 .1-.1.2h-.3l-.1-.1c.1 0 0-.1.1-.1ZM71.7 866.2c.1-.1.2-.1.2-.2 0 .1.2.1.2.2s0 .1-.1.2h-.3l-.1-.1.1-.1ZM62.4 852.4c-.2.4-.4.9-.5 1.3-.1.1-.1.3-.1.4 0 .2.2.1.4.1.1 0 .3-.1.5-.2.3-.1.4-.3.5-.5.3-.4.4-.9.2-1.4-.3-.4-.7-.3-1 .1v.2ZM67.3 850.6c0 .3 0 1.6.7 1.5.3-.1.4-.4.4-.7s0-.6-.2-.9c-.2-.2-.4-.4-.7-.3v.1l-.2.3ZM67.7 852.7c-.1.2-.2.5-.3.7-.1.2-.2.4-.2.6 0 .1-.1.2-.1.4 0 .1-.1.2-.1.4 0 0-.1.2 0 .2s.1-.1.2-.1c.2-.1.3-.3.4-.5s.2-.3.2-.5c.1-.2.1-.4.1-.6v-.3c-.1-.2-.1-.3-.2-.3.1 0 0-.1 0 0Z",
    style: {
      fill: "#43dff6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68 852.6c0 .1 0 .2.1.3q.1 0 .2-.1v-.2q0-.1-.1-.1t-.2.1Z",
    style: {
      fill: "#78e3f9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m71.5 854.1.3-.3.2-.2h.9c.2 0 .4-.1.5 0v.3l-.1.1c-.1.1-.3.1-.5.1s-.5 0-.7.1c-.1 0-.5.2-.6-.1ZM62.8 890.5l.3-.3.2-.2h.9c.2 0 .4-.1.5 0v.3l-.1.1c-.1.1-.3.1-.5.1s-.5 0-.7.1c-.1-.1-.5.2-.6-.1ZM73.5 853.3c.1-.1.4-.2.5-.1v.1q0 .1-.1.1l-.1.1h-.1c-.1 0-.3-.1-.2-.2ZM43.2 859.8c.1-.3.1-.7.3-1 .1-.1.1-.2.2-.4.1-.3.2-.5.4-.7.2-.5.4-1 .5-1.5.1-.4 0-.8-.2-1.2s-.7-.5-1-.1c-.2.2-.4.5-.5.8-.2.3-.3.6-.5 1-.1.4-.1.7-.1 1.1 0 .3-.1.6-.1.9s.1.5.2.8c0 .1.1.2.1.2 0 .1.1.2.2.3.1.1.2.2.3.2.1-.1.4-.2.2-.4ZM44.3 852.7c0 .3 0 .6.1.9.1 0 .2.1.4.1.2-.1.4-.2.5-.4s.2-.7 0-.9c-.1-.1-.1-.2-.2-.3h-.3c-.3 0-.2.2-.4.3l-.1.3ZM44.5 865.3c.3.4.6.7.7 1.2 0 .2.1.3 0 .4-.3.2-.6.1-.8-.2-.4-.4-.8-1.4.1-1.4-.1 0 0 0 0 .1v-.1ZM50.8 872.1c.3-.1.6-.2.9-.2 0 .2.3.3.3.4 0 .2-.2.2-.3.2-.2 0-.3.1-.5 0s-.2-.3-.4-.3v-.1Z",
    style: {
      fill: "#43dff6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m60 872.8.3.3c.1 0 .1.1.2.1l.3.3c.1.1.1.2.2.2.1.1.2.3.3.4 0 .1.1.1.1.2s.1.1.2.2.2.3.3.4c.1.1.1.3.2.4.1.2.2.3.2.5.1.1.1.3.1.4s.1.3.1.4v.7c-.1.2-.2.5-.3.7 0 .1-.1.2-.2.2l-.2.2c0 .1-.1.1 0 .2 0 .1.1.1.1.1.2.2.6.1.9 0h.2c.1 0 .2-.1.3-.1h1c.2 0 .5 0 .7-.1.2 0 .4-.1.5-.1s.2 0 .3-.1c.1 0 .2-.1.2-.1.1 0 .3-.1.4-.1.2-.1.3-.1.5-.2.3-.2.6-.3.9-.4.1 0 .1-.1.2-.1 0 0 .1 0 .1-.1.1-.1.2-.1.3-.2.1-.2-.2-.1-.2 0l-.9.3c-.1 0-.2 0-.4.1h-.4c-.2 0-.4-.1-.5-.2 0-.1-.1-.1-.1-.2l-.2-.2c-.1-.1-.3-.2-.4-.4v-.2c0-.1.1-.1.2-.1.2-.1.4-.1.5-.2l.6-.3c.2-.1.3-.1.5-.2.1 0 .2-.1.3-.1.2 0 .3-.1.5-.1s.3-.1.4-.2c.3-.1.5-.3.7-.5.1-.1.3-.4.2-.6 0-.1 0-.2-.1-.1l-.1.1c-.1.2-.2.3-.4.4-.1.1-.2.1-.3.2-.1.1-.3.2-.4.2-.4.2-.8.3-1.2.4-.3.1-.6 0-.8 0h-1.4c-.2 0-.3 0-.5-.1-.2 0-.4 0-.6-.1-.1 0-.2-.1-.3-.1s-.3 0-.4-.1c-.4-.2-.7-.6-1-.8-.1-.1-.2-.1-.3-.2-.1-.1-.2-.1-.2-.2-.1-.1-.3-.2-.4-.3l-.2-.2c-.1 0-.1-.1-.2-.1s-.1-.1-.2-.1c0 0-.1 0-.2-.1Z",
    style: {
      fill: "#190024"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.9 876.7s.3-.2.4-.3c0 0 0-.1.1-.1.1-.1.2-.1.3 0 .1.1.1.3 0 .4 0 .1-.1.1-.1.2-.1 0-.1.1-.2 0h-.2c-.3-.1-.4-.2-.3-.2Z",
    style: {
      fill: "#190024"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56 870.2c.2.2.4.3.5.5.1.1.2.2.3.2.2.1.5.1.7.2.2.1.4.1.6.1s.5.1.7.2l.3.3v.1l.1.1c0 .1.1.1.1.2l.3.3.2.1c-.1 0-.2-.1-.3-.1s-.1-.1-.2-.1h-.1l-.1-.1c-.1-.1-.3-.2-.5-.3l-.3-.1s-.1 0-.1-.1c0 0-.1 0-.1-.1-.1-.1-.2-.1-.3-.2-.2-.1-.5-.1-.7-.1s-.4-.1-.6-.2c-.1-.1-.3-.1-.4-.1-.2 0-.5-.1-.7-.1-.1 0-.3-.1-.4-.1s-.1-.1-.2-.1-.1-.1-.2-.1c-.2-.1-.3-.2-.5-.4-.2-.1-.3-.2-.5-.4q-.1-.1-.1-.2t.1-.1c.2 0 .4.2.5.3s.2.1.3.2c.1.1.2.1.4.1s.4 0 .5.1c0 0 .1.1.1 0l.1-.1s0-.1.1-.1c0 0 0-.1.1-.1l.1-.1.3-.3c.1 0 .1-.1.2-.1v.2c-.1.1-.1.2-.2.2l-.2.2.1.2c0 .1 0 .2 0 0Z",
    style: {
      fill: "#190024"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.4 875c.1.3.3.6.4.9.1.1.1.2.1.3s.1.3.1.4c0 .4-.1.8.2 1.2q.1.1.2.1h.3c.2 0 .4 0 .6-.1.1 0 .2 0 .3-.1.1-.1.2-.3.2-.4.1-.4.1-.8 0-1.2-.2-.4-.7-.4-1.1-.5-.2-.1-.3-.2-.5-.3-.1-.1-.3-.2-.4-.3-.1 0-.4-.1-.4 0Z",
    style: {
      fill: "#190024"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.6 847.9c-.3.2-.6.3-.9.5-.4.2-.7.3-1 .6-.1.1-.3.2-.4.3-.1 0-.2.1-.2.2-.1.1-.1.2-.1.2-.1.2-.2.4-.4.5-.2.3-.5.5-.8.7-.2.2-.4.3-.5.5-.2.2-.3.4-.5.5-.2.2-.4.3-.6.5l-.3.3-.3.6c-.1.3-.2.6-.3 1-.1.3-.1.6 0 .9 0 .3.1.7.1 1 .1.4.2.8.5 1.1.2.3.4.5.7.7.1.1.2.1.3.2.1.1.2.2.3.2.2.1.3.1.5.1.3 0 .5.1.8.1s.6-.1.8-.1c.3 0 .5.1.8 0s.6-.2.8-.2.3-.1.4-.1c.1-.1.3-.1.4-.2l.9-.6c.2-.1.3-.2.4-.3.2-.2.4-.3.6-.5.4-.4.7-.7 1-1.1.2-.3.4-.7.6-1s.4-.6.5-.9c.1-.2.2-.3.3-.5s.1-.3.2-.5.1-.4.1-.6c0-.3.1-.6 0-1v-.4c0-.1-.1-.3-.2-.4-.1-.1-.1-.2-.1-.4 0-.1-.1-.2-.2-.4s-.3-.3-.4-.4c-.2-.1-.4-.2-.6-.2-.1 0-.3 0-.4-.1-.1 0-.2-.1-.3-.1s-.2 0-.3-.1c-.1 0-.2-.1-.3-.1h-1c-.1 0-.2.1-.3.2v.1l-.1.1-.1.1c-.1.1-.1.2-.2.3s-.2.2-.4.3l-.6.3c-.3.2-.5.4-.7.6-.2.1-.3.3-.4.5-.1.2.1.4.3.2 0 0 .1-.1 0-.1 0-.1-.1 0-.1-.1l.1-.1.2-.2c.1-.1.2-.1.3-.1s.1-.1.1 0v.2s-.1.1-.1.2c0 0-.1.1-.1.2s.3 0 .4 0c.1-.1.3-.1.4-.1s.3-.1.4-.2c.1-.1.2-.1.3-.2.1-.1.3-.1.4-.2.2-.1.6-.4.7 0 .1.2.1.4.1.7v.2q0 .1.1.2c.2.3.4.5.2.9 0 .1-.1.1-.1.2l-.2.2c-.1.1-.2.2-.2.3s-.1.1-.2.2-.3 0-.3-.1.2-.2.1-.4l-.2-.2s-.1.3-.2.3c-.1.2-.1.3-.2.5 0 .1-.1.3-.2.4-.1.1-.2.2-.4.3l-.6.3c-.1 0-.2.1-.2.1h-.7c-.2.1-.4.2-.6.1-.1 0-.2-.2-.3-.3s-.2-.3-.3-.4c-.1-.1-.1-.3-.1-.5s0-.3.1-.5c.1-.1.1-.3.2-.4 0-.1.1-.3 0-.4-.1 0-.2.1-.3.1-.1.1-.2.1-.3.1H52c0-.1.1-.2.1-.3s.1-.2.2-.3c.1-.3.3-.6.4-.9.1-.2.3-.5.5-.6l.3-.3.3-.3c.1-.1.3-.2.4-.3.1-.1.3-.2.4-.3l.3-.3.2-.2c.1-.1.2-.2.3-.4.2.1.3-.1.2-.2Z",
    style: {
      fill: "#5a4862"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.3 850.9c-.1.4-.2.8-.4 1.2 0 .1-.1.2-.1.2 0 .1 0 .2.1.3s.1.2.2.3c.1.1.1.3.1.4 0 .4.3.8.5 1.1.1.2.3.4.5.6.1.1.1.2.2.3.1.1.2.2.3.2.2.1.4.1.6.1s.5-.1.7-.2c.2-.1.3-.2.5-.3s.4-.2.6-.4c.1-.1.3-.2.4-.3.1 0 .1-.1.2-.1s.1 0 .2-.1c.2-.1.3-.4.5-.5l.4-.4c.2-.2.4-.3.6-.5.1-.1.3-.2.2 0s-.2.3-.3.5l-.2.2-.1.1s-.1 0-.1.1c-.1.1.2.1.2.1.1 0 .1.2 0 .3l-.3.3c-.2.1-.4.2-.6.4-.1.1-.3.2-.5.3s-.3.1-.5.2c-.3.1-.6.2-.9.4-.3.2-.6.3-.8.5-.2.1-.3.2-.5.3-.1 0-.1.1-.2 0-.1 0-.1-.1-.2-.1l-.4-.4c-.1-.1-.2-.1-.2-.2-.1-.1-.1-.2-.2-.3-.2-.1-.3-.3-.5-.4l-.3-.3c-.2-.1-.3-.2-.5-.3-.2-.2-.5-.3-.7-.5-.1-.1 0-.2.1-.3h.1l.1-.1c.1-.1.1-.2.1-.4v-.6c0-.3.1-.5.3-.8 0-.2.5-1.1.8-.9Z",
    style: {
      fill: "#5a4862"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.9 856.4c-.1.1-.2.3-.3.4 0 .1-.1.2-.1.3v.2q0 .1.1.2c.1.1.3.1.5.1s.5 0 .7-.1c.5-.2 1-.5 1.5-.9.4-.3.9-.8.6-1.3s-.9-.3-1.3-.2c-.3.1-.6.2-.8.3s-.3.2-.5.3l-.3.3c-.1.1-.1.1-.1.2-.1.2-.1.3 0 .2Z",
    style: {
      fill: "#43dff6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.8 854.8c0-.1.2-.7.4-.5.1 0 .1.1.1.2v.2c0 .2-.1.3-.2.3-.1-.1-.2-.1-.3-.2Z",
    style: {
      fill: "#43dff6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.4 857.9s.1-.4.2-.3v.2c0 .1 0 .2-.2.1Z",
    style: {
      fill: "#43dff6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.8 857.5c.1 0 .7.2.5.4q-.1 0-.2.1h-.2c-.2 0-.3-.1-.2-.3-.1-.1 0-.2.1-.2Z",
    style: {
      fill: "#43dff6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.1 853c-.1-.1-.1-.3-.1-.4v-.3c0-.2-.1-.4-.1-.7 0-.2 0-.4.1-.6 0-.1.1-.3.3-.3h.3c.1 0 .2.2.3.3s.1.3.2.4c0 .1.1.1.1.2v.8c0 .1 0 .2-.1.3s-.1.2-.2.3-.3.1-.4.1c-.2 0-.3 0-.4-.1 0 0-.1 0 0 0Z",
    style: {
      fill: "#43dff6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.8 850c.1.2.2.5.5.5h.2q.1 0 .1-.1l.1-.1v-.2s0-.1-.1-.1c-.3-.3-.8-.5-.8 0Z",
    style: {
      fill: "#43dff6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.3 852.4c-.1.2-.1.4-.2.7q0 .1-.1.2c-.1.1-.1.3-.2.4-.1.2-.1.4-.1.6v.7c0 .2 0 .3-.1.5-.2.6-.5 1.1-.6 1.7 0 .2-.1.4-.2.6-.1.2-.1.4-.2.6v-.3c0-.2 0-.4.1-.5 0-.2 0-.4.1-.5v-1.2c0-.3.2-.6.2-.9s0-.6-.1-.8c0-.1-.1-.2-.1-.3s-.1 0-.2 0l-.6.3c-.1 0-.2.1-.3.1s-.2 0-.2-.1c.3-.2.5-.4.7-.6.1-.1.2-.1.3-.2.1-.1.3-.2.4-.3l.3-.6c.1-.2.2-.4.3-.5s.2-.1.2-.2.1-.2.1-.2c.1-.1.2-.4.4-.4v.4c0 .2-.1.3-.1.5 0 .1-.1.2 0 .3h.2l.1-.1c.1 0 .2 0 .3-.1.1 0 .2 0 .3-.1s.3-.2.4-.3c.1-.1.3-.2.4-.3l.9-.9.3-.3.1-.1c.1-.1.2-.2.3-.2l.3-.3c.1-.1.2-.2.4-.3l.3-.2c.1-.1.2-.1.3-.2.1-.1.1-.2.2-.4.1-.1.1-.2.2-.3l.1-.1.1-.1c0 .1-.1.2-.2.3-.1.1-.2.3-.3.4l-.6.6c-.1.1-.3.2-.5.3l-.3.3c-.2.2-.3.4-.4.6-.2.3-.5.5-.8.8-.2.2-.4.3-.6.5l-.4.4c-.2.2-.4.4-.6.5 0 0-.1.1-.2.1h-.1c.1-.5 0-.4 0-.5Z",
    style: {
      fill: "#5a4862"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.4 859.2c-.2-.1-.4-.2-.6-.2h-.4c-.2 0-.4 0-.6.1-.6.1-1.1.1-1.7.2h-.7c-.3 0-.5.1-.8.1-.1 0-.8.3-.8.1 0-.1.1-.2.1-.2l.6-.3c.2-.1.5-.1.7-.2.2-.1.4-.2.6-.4s.4-.5.3-.8c-.2-.3-.7-.3-1.1-.3h-.7c-.3 0-.6-.1-.9-.2-.2 0-.3-.1-.5-.1s-.3-.1-.5-.1c-.4-.1-.8-.1-1.1 0-.2 0-.4.1-.6.2-.2.1-.5.2-.7.3s-.4.2-.5.3l-.3.3c-.1.3.4.3.5.3h.6c.1 0 .4 0 .4.2v.2c0 .1-.1.1-.1.1-.2.1-.5.2-.7.2-.5.1-1 .2-1.6.2h-.6c-.2 0-.5 0-.7-.1-.1-.1 0-.3.1-.4 0 0 .1-.1.1-.2s0-.1-.1-.1h-.5c-.2 0-.4 0-.6.1-.1 0-.2.1-.3.1-.3.1-.5.3-.7.4l-.3.3c-.1.1-.2.1-.3.2-.1.1-.2.2-.2.3.1.1.2.1.2.1l.1.1v.1l-.3.3c-.1.1-.2.1-.2.2h.1c.1 0 .3-.1.4-.2.3-.1.6-.3.9-.4.3-.1.5-.1.8-.2.3 0 .6-.1 1-.1.1 0 .4.1.4.3v.2c0 .1-.1.1-.1.2s.2.1.3.1h.8c1.3-.2 2.5-.6 3.7-.6h.9c.3-.1.6-.1.8-.2.3-.1.6-.1.8-.1h.8c.3 0 .6-.2.9-.2.4-.1.8-.1 1.2-.2.4-.1.7-.1 1.1 0 .2 0 .4.1.6 0 0 .1 0 .2.1.1.2 0 0-.1-.1-.1Zm-9.9 1-.3.3c-.1.1-.3.1-.4.1s-.2 0-.2-.1c0 0-.1 0-.1-.1v-.4c.2-.1.3-.2.5-.3h.3c.1 0 .3.1.4.2-.1.1-.2.2-.2.3Zm4.6-2.6c.1-.1.3-.1.5-.1s.5 0 .7.1c.1.1.2.1.1.2s-.3.2-.4.2c-.2.1-.3.1-.5.2-.1 0-.1.1-.2.1s-.1 0-.2.1c-.1-.1-.1-.2-.2-.4-.1 0 .1-.3.2-.4Zm-1.4.1c.1 0 .3.1.4.1v.2c-.1 0-.2.2-.4.1l-.1-.1h-.1c-.1 0-.1-.1-.1-.1-.1-.1 0-.1 0-.2l.1-.1c.1.1.2.1.2.1Zm-2 .2c-.1 0-.4.1-.4-.1 0-.1.1-.1.2-.2.2-.1.3-.2.5-.2-.1 0 0-.1.2-.2s.5-.1.7-.1c.1 0 .5.1.5.3v.2c0 .1-.1.1-.1.1-.2.1-.5.2-.8.2-.2.1-.5 0-.8 0Zm2.4 1.8c-.3.1-.6.1-.8.2-.3.1-.6.1-1 .1-.2 0-.5 0-.7-.2 0-.1-.1-.1-.1-.2v-.2c0-.3.2-.6.4-.8.1-.1.2-.1.3-.1s.2 0 .2-.1c.2-.1.4-.1.6-.1-.3.1-.1.1 0 .1s.3 0 .4.1c.2.1.3.1.5.1.3.1.7.3.9.6.2.2-.5.4-.7.5Z",
    style: {
      fill: "#5a4862"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51 862c.1.5.1.8.5 1.1.1.1.2.1.4 0 .2 0 .3-.2.5-.2h.6c.1 0 .1-.1.2-.1.1-.1.3-.3.5-.3h.2c.1 0 .1.1.2.1.1.1.3.3.3.4.1.1.3 0 .4-.1.4-.2.7-.6 1-.8.2-.2.4-.3.6-.5l.5-.5c.4-.3.8-.5 1.2-.8.3-.2.7-.4 1-.6.4-.2.7-.4 1.1-.5.4-.2.8-.5 1.2-.9.5-.4.9-.9 1.4-1.3.5-.4 1-.8 1.2-1.4.2-.6.2-1.3.4-1.9l.3-.9c0-.1.1-.2.1-.4v-.4c.1-.3.1-.7 0-1-.1-.4-.1-.7-.3-1l-.3-.9c0-.3-.2-.6-.3-.8-.2-.3-.6-.8-.5-1.2.1 0 .3.3.3.4.1.2.2.5.3.7.1.2.2.5.3.7s.3.4.4.6c.2.4.3.7.5 1.1 0 .1.1.1.1.2s.1.1.2.2c.2.1.3 0 .4.2 0 .1.1.1.1.2v.2c0 .1-.1.1 0 .2 0 .1.1.2.2.2.2.2.7.1.6.5l-.3.6c-.2.2-.4.5-.7.7-.2.2-.3.4-.5.6-.1.1-.2.2-.2.3-.1.1-.1.3-.2.4 0 .1-.1.2-.2.2-.1.1-.1.2-.2.3-.1.2-.3.3-.4.5l-.3.6c-.1.2-.2.4-.4.5-.1.1-.1.2-.2.3l-.3.3c-.3.3-.7.5-1.1.7s-.8.5-1.2.7l-.9.6c-.2.3-.1.8-.5.9-.4.2-.8 0-1.2 0-.5.1-.9.5-1.1 1-.1.2-.3.5-.5.7s-.4.3-.7.4c-.3.1-.5.3-.8.3-.2.1-.4.2-.6.2s-.4-.2-.6-.3c-.1 0-.2-.1-.3-.1s-.2 0-.3.1c-.7.2-1.5.9-2.2.3-.2-.2-.3-.5-.3-.7 0-.1-.1-.3.4-.6Z",
    style: {
      fill: "#5a4862"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.1 874.8c.2.2.4.5.6.8l.2.2.3.3c.3.2.5.4.8.6.3.2.5.4.8.6.2.1.5.2.8.3.1 0 .3.1.4.1.1.1.3.2.5.2.2.1.4.1.6.1.2.1.5.2.7.2l1.5.6c.5.2.9.5 1.4.8.8.4 1.8.6 2.7.6.3 0 .7.1 1 .1h.7c.3 0 .5-.1.8-.2.3-.1.6-.1.9-.2l.9-.3c.2-.1.4-.2.5-.3l.6-.3c.1-.1.2-.1.3-.2l.3-.3c.2-.1.4-.3.5-.4.2-.2.4-.3.6-.4.1.1.1.2.1.2l-.2.2c-.1 0-.2.1-.3.2-.2.2-.4.4-.6.5-.2.2-.4.3-.6.4-.1.1-.2.1-.3.2-.1.1-.3.2-.5.2l-.6.3c-.1.1-.3.1-.4.2-.2.1-.3.2-.5.3s-.6.3-.4.5c.1.1.2.2.3.2.2.1.4.1.6.2.3.1.6.3.9.4.2.1.4.2.7.3.1 0 .2.1.3.1.1.1.2.1.2.2.2.1.2.5.4.6s.9.4 1.1.3c.3 0 .3-.7.6-.8.2 0 .3-.1.5-.1.3 0 .7.1 1 .1.7.1 1.4 0 2.1 0 .4 0 .7-.1 1.1-.1.2 0 .4.2.7.2.2.1.5.1.8.1s.7 0 1 .1c.6.1 1.2.3 1.8.3.4 0 .8.1 1.1.3.1.1.2.2.4.3.1.1.1.2.2.2-.2 0-.3.2-.5.1s-.2-.3-.4-.3c-.2-.1-.5-.1-.7-.2H67c-.2 0-.3-.1-.5-.1h-1c-.3-.1-.6-.1-1-.2-.3 0-.5 0-.8-.1-.1 0-.3 0-.4-.1h-.4c-.2 0-.5-.1-.7-.1h-.6c-.1 0-.3-.1-.4-.1h-.4c-.2 0-.5 0-.7.1-.3 0-.5.1-.7.2-.2.1-.4.1-.5.3-.2.3 0 .7.2 1-.1 0-.2-.1-.3-.1s-.1 0-.2-.1c0-.1 0-.2-.1-.3 0-.1-.1-.2-.2-.2-.3-.3-.9-.4-1.3-.5-.8-.2-1.5-.4-2.2-.9-.2-.2-.5-.3-.7-.5-.2-.1-.4-.3-.6-.4-.3-.2-.7-.4-1.1-.5-.4-.1-.7-.1-1.1-.2-.5-.1-1 0-1.4-.1h-.7c-.2 0-.5-.1-.7-.1s-.4-.1-.6-.2l-.6-.3c-.5-.1-.9-.3-1.4-.5-.3-.1-.6-.2-.9-.4-.3-.2-.6-.2-.9-.4-.8-.4-1.6-.9-2.4-1.2-.3-.1-.7-.2-1-.3h-.3c-.2 0-.1 0-.2-.2-.1-.1-.1-.3-.2-.4-.1-.1-.2-.3-.3-.4 0-.1-.1-.1-.1-.2-.1-.1-.1-.2-.2-.3-.2.1-.1-.1-.3-.8Z",
    style: {
      fill: "#43dff6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.6 879c.1.2.3.3.5.4.1.1.3.1.4.1.3.1.6.1.8.2.4 0 .8 0 1.2-.1.5 0 1-.2 1.3-.6.2-.2.3-.4.3-.6 0-.3-.2-.6-.5-.8-.6-.5-1.5-.6-2.2-.5-.5 0-1 .1-1.2.5-.1.1-.1.2-.2.3-.1.1-.1.3-.2.4 0 .1-.1.2-.1.3.1.2 0 .4-.1.4Z",
    style: {
      fill: "#190024"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.1 879.1c-.1-.1-.2-.4-.3-.5h-.2c-.1 0-.2.1-.2.2v.3c0 .1.1.2.2.2.2.1.4 0 .5-.1.1-.2 0-.4-.2-.4l.2.3Z",
    style: {
      fill: "#190024"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M85.8 871.7v-1.8c0-.3 0-.5.1-.8.1-.5 0-1.1 0-1.7 0-.7-.1-1.4-.2-2.1-.1-.4-.1-.8-.2-1.1s-.2-.5-.2-.8c-.2-.6-.1-1.2-.3-1.8-.1-.5-.3-.9-.5-1.3-.3-.4-.4-.9-.8-1.3-.3-.4-.5-.8-.8-1.2s-.7-.8-.9-1.3c-.1-.2-.1-.4-.2-.6 0-.2-.1-.3-.1-.4 0-.2.2-.2.2-.4-.1-.2-.2-.5-.3-.7-.3-.6-.8-1.2-1.3-1.7-.4-.4-.6-.8-1-1.2l-.9-.9c-.4-.3-.9-.5-1.4-.6-.2-.1-.4-.2-.5-.3-.2-.1-.5 0-.7 0-.6 0-1.2.1-1.7-.2-.1-.1-.3-.2-.4-.2-.2 0-.4-.1-.5-.2-.2-.2-.5-.5-.5-.8s.3-.5.3-.8c.1-.3.1-.8-.1-1-.4-.3-1-.4-1.5-.6-.8-.2-1.6-.1-2.3-.3-.2-.1-.3-.2-.5-.3s-.5-.1-.7-.1H67c-.3-.1-.5 0-.8-.1-.2 0-.5-.1-.6-.2-.1-.1-.1-.3-.2-.5-.2-.3-.8-.4-1.1-.5-.4-.1-.9 0-1.3 0-.2 0-.4-.1-.7-.1-.1 0-.2 0-.4-.1h-.3l-1.2-.3c-.5-.1-1-.1-1.5.1-.3.1-.7.2-1 .3-.4.1-.8.3-1.2.3-.8.1-1.6.4-2.4.5h-.2c1.9-.7 4-1.2 6-1.4.8-.1 1.6-.1 2.4-.1 2.8 0 5.5.5 8.1 1.4.8.3 1.5.6 2.3.9 3.2 1.5 6 3.6 8.2 6.2 2.3 2.6 3.9 5.7 4.9 9.1 1 3.3 1.2 6.8.7 10.3-.5 3.4-1.7 6.7-3.6 9.7v-.2c.1-.5.5-1 .7-1.5.3-.7.7-1.4 1-2.1.1-.4.2-.8.4-1.2.1-.3.2-.7.2-1 .1-.7.2-1.4.2-2 .1-.3.2-.7.2-1Z",
    style: {
      fill: "url(#x)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2 850.3c.3.3.5.5.8.7l.3.3.3.3c.1.1.3.2.5.2s.4 0 .6-.1c.1 0 .1-.1.2-.1 0 0 .1-.1.1-.2v-.4c-.1-.2-.3-.3-.4-.4l-.2-.2c-.1 0-.1-.1-.2-.2s-.2-.1-.3-.2c-.1-.1-.2-.1-.4-.1s-.4-.1-.6 0h-.3c-.1 0-.2.1-.2.1 0 .2-.1.3-.2.3 0 .1.1.2 0 0Z",
    style: {
      fill: "url(#y)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3 851.7c.3 0 .5-.1.8.2.1.1.2.2.2.3s.1.2 0 .3c0 0-.1.1-.2.1h-.2c-.1 0-.3-.1-.4-.2l-.1-.1-.1-.1c0-.1-.1-.1-.1-.2.1-.1.1-.2.1-.3Z",
    style: {
      fill: "url(#z)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9 845.5c-.7-.3-1.5-.6-2.3-.9-2.6-.9-5.3-1.4-8.1-1.4-.8 0-1.6 0-2.4.1-5.2.5-10.1 2.7-14 6.2 3.8-3.2 8.5-5.2 13.4-5.7.8-.1 1.6-.1 2.4-.1 2.8 0 5.5.5 8.1 1.4.8.3 1.5.6 2.3.9 3.7 1.7 6.9 4.3 9.3 7.5s4 7 4.6 11 .2 8.1-1.2 11.8c-1.4 3.8-3.7 7.2-6.7 9.9 3.1-2.6 5.6-6 7.1-9.8s2-7.9 1.4-12c-.5-4.1-2.1-7.9-4.5-11.2-2.5-3.3-5.7-5.9-9.4-7.7Z",
    style: {
      fill: "url(#A)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8 884c.1.2.2.3.3.4 0-.1.2-.1.2-.2 0 0 .1-.1.1-.2v-.3c-.1-.1-.1-.2-.2-.2-.2.1-.3.3-.4.5ZM76.2 883.2c.2-.3.4-.5.6-.8.1-.1.2-.2.3-.2s.1 0 .2.1c0 .1-.1.2-.1.2-.1.2-.3.3-.5.4-.1 0-.1.1-.2.1s-.2.1-.2.1l-.1.1Z",
    style: {
      fill: "#3261d6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2 869.7c0 .2.1.4.2.5.2 0 .2-.3.2-.5v-.5c0-.1 0-.5-.1-.5s-.1.1-.1.1c-.1.3-.1.5-.2.9Z",
    style: {
      fill: "#438bf6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5 846.9c-.3 0-.8-.2-1.1-.1h-.2c0 .2.5.3.6.4.2.1.5.2.8.2.1 0 .4 0 .5-.1.1-.3-.4-.4-.6-.4Z",
    style: {
      fill: "#43dff6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2 846.2c.5-.3 1.2-.9 1.8-.7-.1.1-.2.3-.4.3-.2.1-.4.2-.6.4-.1.1-.3.2-.4.3-.6.4-1.2.7-1.8 1-.4.2-.9.2-1.4.3-.8.2-1.5.5-2.3.6-.1 0-.7.1-.8-.1.2 0 .3-.1.5-.1.3-.1.5-.1.8-.1s.6-.1.9-.2c.2-.1.4-.1.6-.2.1-.1.2-.1.3-.1s.3-.1.4-.1.2-.1.3-.1h.4c.2-.1.5-.1.7-.2.2-.1.4-.2.5-.3.4-.2.5-.4.5-.7ZM50.9 848.9c-.2.4-.5.8-.4 1.2 0 .1 0 .2.1.3q.1 0 .2-.1c.1 0 .2-.1.3-.2.1-.1.2-.1.3-.2.1-.1.2-.2.4-.3l.3-.3c.1-.1.3-.3.2-.5s-.3-.1-.5-.1-.3-.1-.6 0c-.1 0-.2.1-.3.2-.1 0-.2.1-.2.2l.2-.2ZM49.5 875.1s.4.6.6.7c.2 0 .1 0 .1-.1.1-.1.1-.2 0-.3 0-.1-.1-.1-.1-.2l-.1-.1c-.1-.1 0-.1-.2-.1-.1 0-.2 0-.1.1h-.2Z",
    style: {
      fill: "#438bf6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5 886.9c.2.2.4.3.7.5h.1c.1 0 .2 0 .2-.1s-.2-.3-.3-.4c-.2-.3-.6-.5-.9-.7-.1-.1-.4-.3-.5-.3-.2 0 0 .2 0 .3.1.1.2.1.2.2l.2.2.1.1c.1.1.1.2.2.2ZM50.5 885.2c-.2-.2-.3-.5-.4-.7.1-.1.3.2.4.3.1.1.1.2 0 .4Z",
    style: {
      fill: "#3261d6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65 871.4c.1.1.1.2.2.4l.1.1c.1-.1 0-.3-.1-.4s-.1-.3-.2-.3v.2ZM64 865.9c-.1 0-.2.1-.2.2l-.1.1c0 .1-.1.2-.1.3s-.1.2-.1.3-.1.2-.1.3-.1.2-.1.3v.4c0 .1.1.3.1.4 0 0 0 .1.1.1l.1.1c.1 0 .2-.1.2-.1s.1-.1.1-.2 0-.1.1-.2v-1.2c0-.1.1-.2.1-.3v-.2c0-.3-.1-.3-.1-.3ZM64.3 865.8c.1 0 .1.1.2.1 0 0 .1 0 .1-.1 0 0 .1 0 .1-.1v-.1l-.1-.1h-.2c0 .1-.1.2-.1.3Z",
    style: {
      fill: "#438bf6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8 864.7q-.1.1-.1.2v.4c0 .1 0 .2.2.2q.1 0 .2-.1c.1 0 .2-.1.3-.1s.2-.1.2-.1c.1 0 .1-.1.2-.2q.1-.1.1-.2v-.2s0-.1-.1-.1l-.1-.1h-.3c-.1 0-.2 0-.2.1l-.1.1c-.2-.1-.3 0-.3.1Z",
    style: {
      fill: "#78e3f9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9 864.5q0-.1.1-.2h.2c.1 0 .1.1.1.2v.2c0 .1-.1.1-.1.2H65l-.1-.1v-.3c0 .1 0 0 0 0ZM69.5 866.7q.1-.1.2 0c.1.1.2.2.2.3s-.1.2-.2.2-.2-.2-.2-.3-.1-.1-.2-.2-.2-.2-.4-.2c-.1 0-.2-.1-.3-.1s-.2 0-.3-.1c-.3-.1-.6 0-.9.1-.1.1-.4.2-.3.2-.1.2-.2.3-.2.5.1 0 .2.1.2.1.1 0 .3.1.4.1.2.1.4.1.6.2.2 0 .4 0 .6.1h.2q.1 0 .2-.1l.1-.1q0-.1.1-.2c0-.2-.1-.4-.2-.6l.4.1Z",
    style: {
      fill: "#438bf6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5 860.3c.1-.2.2-.3.3-.5h.1q.1 0 .2.1c.1.2 0 .6-.2.8-.1.1-.4.2-.5.1q-.1-.1-.1-.2v-.3h.2Z",
    style: {
      fill: "#78e3f9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.6 860.9c0 .2 0 .5.1.7v1c0 .1-.1.1-.1.2s-.1.2-.1.3v.3h.1q.1 0 .2.1h.3c.1 0 .3.1.4.1.1.1.3 0 .4.1.1.1.1.2.2.3.1.1.1.2.2.3.2.2.3.5.4.7.1.2.2.5.3.8.1.2.2.4.3.5.1.2.3.3.5.4.1 0 .1.1.2.1l.3.3 1.2 1.5.6.6.2.2c.1.1.2.1.4.2.1.1.3.1.4.2.1 0 .2.1.3.1s.1 0 .2.1.1.2.2.2c.1-.1-.1-.4-.2-.4-.2-.1-.3-.2-.5-.2-.1 0-.2-.1-.3-.1s-.2-.1-.3-.2c-.1-.1-.2-.1-.3-.2l-.3-.3c-.2-.1-.3-.3-.4-.5 0-.1-.1-.2-.1-.3s-.1-.2-.1-.4v-.3c0-.1 0-.2.1-.3.1-.2.1-.4.1-.6s0-.4-.1-.5c-.1 0-.2 0-.2.1-.1.1-.1.2-.1.2v.4c0 .1 0 .2-.2.2s-.3 0-.5-.2c-.1-.1-.2-.3-.4-.4-.2-.1-.3-.3-.4-.5-.2-.3-.3-.5-.5-.8s-.3-.6-.4-.9c-.1-.3-.3-.7-.6-.9-.1-.1-.2-.1-.4-.2-.1 0-.1-.1-.1-.1v-.2c0-.4-.1-.8-.3-1.2 0-.1-.1-.5-.3-.5h-.4Z",
    style: {
      fill: "#5a4862"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m53.1 865.2-.1-.4c0-.1-.1-.1 0-.2 0 0 0-.1.1-.1l.1-.1c.1 0 .3.3.3.4v.4c-.1.1-.3.1-.4 0Z",
    style: {
      fill: "#5a4862"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.1 861c.8-.1 1.6-.3 2.4-.4.2 0 .4-.1.6-.1h.4c.1 0 .3.1.4.2.1 0 .2.1.3.1s.2.1.4.1.3.1.5.2c.1 0 .3.1.4.1.1.1.2.1.4.2.1.1.2.1.3.1q.1.1.2.1c.2.1.4.1.6.2.1.1.2.2.3.2h.3c.1 0 .2 0 .3.1.2 0 .3.1.5.1.1 0 .3.1.4.1s.2.1.3.2c.1.1.3.2.4.3 0 0 .1.1 0 .1 0 0-.1 0-.1-.1-.2-.2-.4-.3-.6-.3-.3-.1-.6-.1-.9-.2h-.2c-.1 0-.1-.1-.2-.1s-.2 0-.4-.1c-.1 0-.2-.1-.3-.2-.1 0-.2-.1-.3-.2-.1-.1-.3-.2-.5-.3s-.4-.2-.7-.3c-.4-.1-.7-.3-1-.4-.2 0-.4-.1-.7 0h-.9c-.2 0-.3 0-.5.1-.1 0-.2.1-.4.1-.1.1-.2.1-.4.1-.1 0-.1.1-.2.1 0 .1-.1.1-.1.2v.3c.1.1.1.2.2.2.1.1.3.1.4.2.1.1.2.1.3.2-.1 0-.2-.1-.3-.1s-.2-.1-.4-.1c-.3 0-.5-.1-.8-.3-.1-.1-.2-.1-.2-.2l-.3-.3q-.1-.1-.1-.2c0 .1.1.1.2 0Z",
    style: {
      fill: "#5a4862"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.8 872.5c.1-.3.2-.6.4-.8 0-.1.1-.2.2-.3l.1-.1v.4c-.1.2-.1.3-.1.5v.7c0 .3.1.6.1.9v1.3c0 .1-.1.2-.1.4 0 .1-.1.2-.1.4 0 .1-.1.2-.1.4 0 .1 0 .2-.1.3v.2c.1 0 .1-.1.1-.2s.1-.2.2-.2c.1-.1.1-.2.2-.4s.1-.3.1-.5v-.2c0-.1.1-.2.1-.4s.1-.3.1-.5V873c0-.3.1-.5.2-.7.2-.6.3-1.2.5-1.7 0 0 .2-.4.3-.4v.7c0 .1.1 0 .2-.1 0 0 .1-.1.2-.1 0 0 .1 0 .1-.1l.1-.1s.1 0 .1-.1l.1-.1h.1s.1.1.1.2v.2c0 .2-.2.3-.3.5l-.3.6c0 .1-.1.2-.1.3v2.2q0 .1.1.2c.1.1.1-.1.1-.1 0-.2 0-.4.1-.5 0 0 .1-.3.2-.3v.1l.1.1c.1.1.1.2.2.4 0 .1.1.2.1.3s0 .2.1.4c0 .1.1.3.2.3.2.1.3-.2.3-.3.1-.1.1-.2.1-.3s.1-.3.1-.4c0-.2.1-.3.1-.5v-.5c0-.3 0-.6.1-.8 0-.1 0-.3.1-.4 0-.2 0-.3.1-.5.1-.3.1-.5.1-.8 0-.2 0-.3.1-.5v-1.5c0-.3 0-.6-.1-.9v-.5c0-.2 0-.3-.1-.5-.1-.4-.1-.8-.1-1.1s.1-.6.1-.9v-.5c0-.2-.1-.5-.2-.7-.1-.4-.3-.7-.4-1s-.2-.7-.3-1l-.3-.6c0-.1-.1-.1-.2-.2s-.1-.2-.2-.2c-.1-.1-.2-.3-.3-.4l-.2-.2v.1c0 .1.1.1.1.1l.3.6c.1.2.2.3.3.5 0 .1.1.2.1.2 0 .1.1.2.1.3s.1.2.1.3.1.2.1.3c.1.2.2.4.2.6.1.4.2.8.2 1.3.1.6 0 1.2 0 1.7 0 .3 0 .6.1.9 0 .2.1.5 0 .7 0 .1-.1.3-.1.4s0 .2-.1.3c0 .1 0 .2-.1.2 0 .1-.1.2-.1.3-.1.1-.2.2-.3.2s-.1-.1-.1-.1c-.1 0-.1-.1-.2-.1-.1-.1-.2-.2-.2-.3-.1-.1-.1-.2-.1-.4-.1-.1-.1-.2-.2-.4-.1-.1-.2-.2-.2-.4l-.3-.6c0-.2-.2-.4-.3-.6-.1-.1-.2-.2-.3-.1-.1.1 0 .3 0 .4 0 .2.1.5.1.7v1.9c0 .1-.1.2-.1.3v.4c0 .1 0 .3-.1.4-.1.1-.2.2-.4.3l-.2.2-.3.3c0 .1-.1.1-.1.2s0 .2-.1.2c-.1.2-.1.4-.1.6v.3c-.1.1-.2.2-.1.3Z",
    style: {
      fill: "#5a4862"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71 882.9c.6-.3 1.3-.5 1.8-1 .1-.1.3-.2.4-.3s.2-.2.2-.3v-.2c0-.1-.1-.1-.1-.2-.2-.1-.4-.1-.6 0-.2 0-.4.1-.7.2-.4.1-.8.1-1.1.1-.2 0-.3.1-.5.1-.2.1-.3.2-.4.4s-.2.3-.2.5v.3c0 .1.1.2.2.3.1 0 .2.1.2.1h.3c.1 0 .5-.1.5 0Z",
    style: {
      fill: "#190024"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.6 880.6c.1 0 .2 0 .3.1q-.1.1-.2.1h-.3l-.1-.1s0-.2.1-.2l.2.1Z",
    style: {
      fill: "#190024"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M81 855.2c0-.2-.1-.3-.2-.4l-.1-.1h-.2c-.1 0-.1.1-.1.1v.2q0 .1.1.2l.1.1h.2q.1 0 .2-.1c-.1 0 0 0 0 0q-.1 0 0 0-.1 0 0 0-.1 0 0 0-.1 0 0 0ZM79 856.4s-.1 0 0 0q-.1 0 0 0-.1 0 0 0-.1.1 0 0c0 .3 0 .1 0 0ZM82.2 857.2q-.1 0 0 0c-.1 0-.1.1 0 0q-.1.1 0 0 0 .1 0 0ZM83.2 870.1s.1 0 0 0q-.1.1 0 0c-.1.1-.1 0 0 0-.1 0 0 0 0 0ZM77.2 854.5s.1 0 0 0q-.1.1 0 0-.1 0 0 0ZM79.9 854.5c.1-.1.2-.3.2-.4v-.2h-.3c-.1 0-.1.1-.1.1s-.1.1-.1.2v.2c0 .1.1.1.1.1h.2c.1 0 0 0 0 0q0-.1 0 0 0-.1 0 0 0-.1 0 0ZM85.3 868.5c.1-.1.2-.3.2-.4v-.2h-.3c-.1 0-.1.1-.1.1s-.1.1-.1.2v.2c0 .1.1.1.1.1h.2q0-.1 0 0 0-.1 0 0 0-.1 0 0 0-.1 0 0ZM75.9 852v-.2h-.1s-.1 0-.1.1v.3c.1 0 .2-.1.2-.2ZM76.1 850.6q0-.1 0 0-.1 0 0 0l-.1.2c.1 0 .1-.2.1-.2ZM76.2 851.3s-.1 0 0 0c-.1 0-.1-.1 0 0q-.1-.1 0 0-.1-.1 0 0 0-.1 0 0 0-.1 0 0 0-.1 0 0ZM75.7 851.5q0-.1 0 0-.1 0 0 0ZM75.4 854.1c-.1.1 0 .1 0 0q0 .1 0 0 0 .1 0 0ZM76.5 851s.1-.1 0 0q.1-.1 0 0 0-.1 0 0 0-.1 0 0-.1-.1 0 0-.1-.1 0 0ZM75.3 850.8s0 .1 0 0q0 .1 0 0c-.1.2-.1.1 0 0q-.1.1 0 0-.1.1 0 0-.1 0 0 0 0 .1 0 0ZM76.1 850.9q.1 0 0 0 0 .1 0 0c0 .1 0 0 0 0ZM76.4 850.6q.1 0 0 0 .1-.1 0 0 0-.1 0 0 0-.1 0 0 0-.1 0 0 0-.1 0 0ZM76 851.7q0-.1 0 0 .1-.1 0 0ZM75.1 851.1s-.1 0 0 0q-.1 0 0 0c-.1 0-.1-.1 0 0-.1-.1 0-.1 0 0q0-.1 0 0 0-.1 0 0 0-.1 0 0 0-.1 0 0ZM81 853.8v-.2h-.1s-.1 0-.1.1v.3l.2-.2ZM78.2 852.5s-.1 0 0 0q-.1.1 0 0-.1.1 0 0-.1.1-.1.2c.1.1.1-.1.1-.2ZM77.8 852.8s0 .1 0 0c0 .1 0 0 0 0q.1 0 0 0ZM77.4 852.8q-.1 0 0 0c.1 0 0 0 0 0q-.1.1 0 0-.1 0 0 0c-.1 0-.1-.1 0 0q-.1-.1 0 0c-.1-.1 0-.1 0 0ZM76.7 852.9q-.1 0 0 0-.1.1 0 0-.1.1 0 0c-.1.1 0 .1 0 0q0 .1 0 0 0 .1 0 0 0 .1 0 0ZM78.2 852.8s0 .1 0 0c0 .1.1.1 0 0q-.1.1 0 0-.1.1 0 0c0 .1 0 0 0 0ZM77.2 853q-.1 0 0 0-.1 0 0 0-.1 0 0 0-.1 0 0 0-.1 0 0 0-.1-.1 0 0c-.1-.1 0-.1 0 0ZM81.8 868.3v-.2h-.1s-.1 0-.1.1v.3l.2-.2ZM82.8 870.4v-.2h-.1s-.1 0-.1.1v.3c.1 0 .2-.1.2-.2ZM82 866.8q-.1.1 0 0-.1.1 0 0-.1.1-.1.2c.1.1.1-.1.1-.2ZM83.1 872.1q-.1 0 0 0-.1 0 0 0c-.1.1-.1 0 0 0ZM83.3 860.1q-.1 0 0 0c.1 0 0 0 0 0q-.1.1 0 0c-.1.1-.1 0 0 0q-.1 0 0 0c-.1 0 0 0 0 0ZM82.3 872.3q-.1.1 0 0c-.1.1-.1 0 0 0q-.1 0 0 0c-.1 0 0 0 0 0ZM83.1 860.3q-.1.1 0 0-.1 0 0 0-.1 0 0 0-.1 0 0 0-.1 0 0 0-.1 0 0 0c-.1 0 0 0 0 0ZM76.8 850.5q-.1-.1 0 0-.1 0 0 0c-.1 0 0 0 0 0ZM76 852.3q-.1-.1 0 0c-.1-.1-.1 0 0 0q-.1 0 0 0ZM75.6 856.2c.1-.1.2-.3.2-.4v-.2h-.3c-.1 0-.1.1-.1.1s-.1.1-.1.2v.2c0 .1.1.1.1.1s.1.1.2 0c-.1 0 0 0 0 0q-.1 0 0 0-.1 0 0 0ZM80.3 856.5v-.2h-.1s-.1 0-.1.1v.3l.2-.2ZM82.8 874.9v-.2h-.1s-.1 0-.1.1v.3c.1-.1.3-.2.2-.2Z",
    style: {
      fill: "#43dff6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7 855.2c0-.1-.1-.1 0 0q-.1-.1 0 0-.1-.1 0 0c-.1 0 0 0 0 0ZM80.5 855c0-.1-.1-.1 0 0-.1 0-.1.1 0 0q-.1.1 0 0-.1.1-.1.2c.1.1.1-.1.1-.2ZM81.2 854.3s-.1 0 0 0q-.1 0 0 0c-.1.1 0 .1 0 0ZM80.5 855.7q0-.1 0 0 0-.1 0 0 0-.1 0 0 .1-.1 0 0 .1-.1 0 0ZM80.1 855.9s-.1-.1 0 0q-.1 0 0 0-.1 0 0 0-.1 0 0 0ZM80.9 855.4q0-.1 0 0-.1-.1 0 0-.1-.1 0 0-.1-.1 0 0-.1 0 0 0-.1 0 0 0-.1 0 0 0ZM79.6 855.6q-.1 0 0 0-.1-.1 0 0-.1-.1 0 0-.1-.1 0 0 0-.1 0 0 0-.1 0 0c0 .1-.1 0 0 0q-.1 0 0 0ZM79.6 855.4q0-.1 0 0-.1-.1 0 0c-.1-.1-.1 0 0 0q-.1 0 0 0-.1 0 0 0ZM80.5 855.3s.1 0 0 0q0 .1 0 0-.1.1 0 0-.1.1 0 0ZM80.8 855q0-.1 0 0 0-.1 0 0 0-.1 0 0-.1-.1 0 0-.1-.1 0 0ZM80.4 856.1s-.1 0 0 0q-.1 0 0 0-.1-.1 0 0 0-.1 0 0ZM81.2 854.9q-.1-.1 0 0-.1 0 0 0-.1 0 0 0-.1 0 0 0-.1 0 0 0-.1 0 0 0-.1 0 0 0ZM78.8 855.7v-.2h-.1s-.1 0-.1.1v.3c.1 0 .2-.1.2-.2ZM82.3 858.6q0 .1 0 0-.1.1 0 0-.1 0 0 0-.1 0 0 0-.1 0 0 0c0-.1 0 0 0 0ZM83.4 856.9s-.1 0 0 0q-.1.1 0 0-.1.1 0 0-.1.1-.1.2c.1.1.1-.1.1-.2ZM81.3 857s0-.1 0 0q-.1-.1 0 0 0-.1 0 0 0-.1 0 0 0-.1 0 0 0-.1 0 0 0-.1 0 0 0-.1 0 0ZM82.6 857.2q-.1 0 0 0c.1 0 0 0 0 0-.1.1-.1 0 0 0q-.1 0 0 0-.1 0 0 0ZM82.4 857.1c-.1-.1-.1 0 0 0q-.1 0 0 0-.1 0 0 0-.1 0 0 0ZM82.3 857.4s.1 0 0 0c.1 0 0 0 0 0q0 .1 0 0 .1 0 0 0 .1 0 0 0ZM83.1 857.1q0-.1 0 0c-.1-.1-.1 0 0 0ZM80.3 853.2c0-.1-.1-.1 0 0q-.1 0 0 0-.1 0 0 0-.1 0 0 0ZM78.7 854.6q-.1 0 0 0-.1 0 0 0-.1 0 0 0-.1 0 0 0-.1 0 0 0-.1-.1 0 0-.1-.1 0 0 0-.1 0 0c0-.1 0 0 0 0s-.1 0 0 0ZM79.9 859.3q-.1-.1 0 0c-.1-.1 0-.1 0 0q0-.1 0 0 0-.1 0 0 0-.1 0 0ZM78.9 855.4q-.1 0 0 0c-.1-.1 0-.1 0 0 0-.1.1-.1 0 0ZM77.8 854.8q-.1 0 0 0-.1 0 0 0-.1 0 0 0c-.1 0 0-.1 0 0q0-.1 0 0Z",
    style: {
      fill: "#43dff6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#B)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.2 889.8c1.5-.7 2.9-1.5 4.3-2.3 1.4-.8 2.8-1.7 4.1-2.5 2.7-1.8 5.3-3.7 7.8-5.8 1.2-1 2.4-2.1 3.6-3.2 1.2-1.1 2.3-2.2 3.4-3.4.3-.3.5-.6.8-.9.3-.3.5-.6.8-.9.5-.6 1-1.3 1.5-1.9.2-.3.4-.7.6-1 .2-.4.4-.7.5-1.1.1-.4.2-.8.2-1.2s-.1-.8-.3-1.1c-.2-.3-.5-.6-.9-.8-.3-.2-.7-.4-1.1-.5-.8-.2-1.6-.4-2.4-.4-1.6-.1-3.2-.1-4.8-.1s-3.2.1-4.9.1h-1.2c-.4 0-.8-.1-1.2-.1-.1 0-.2 0-.3-.1-.1 0-.2-.1-.3-.1-.1-.1-.2-.1-.2-.2s-.1-.2 0-.3c0-.2.1-.4.3-.6.1-.2.3-.3.4-.5.6-.6 1.2-1.1 1.8-1.6s1.3-.9 2-1.4c1.3-.9 2.7-1.7 4.1-2.6 2.8-1.6 5.6-3.2 8.5-4.7-2.9 1.5-5.7 3.1-8.5 4.7-1.4.8-2.8 1.7-4.1 2.6-.7.4-1.3.9-2 1.4s-1.3 1-1.8 1.6c-.1.1-.3.3-.4.5-.1.2-.2.3-.3.5v.3c0 .1.1.2.2.2.2.1.4.1.6.2.4.1.8.1 1.2.1h1.2c1.6 0 3.2-.1 4.9-.1s3.2-.1 4.9.1c.8.1 1.6.2 2.4.4.4.1.8.3 1.1.5.4.2.7.5.9.8.2.4.3.8.3 1.2s-.1.8-.2 1.2-.3.8-.5 1.1c-.2.4-.4.7-.6 1-.5.7-.9 1.3-1.5 1.9-.3.3-.5.6-.8.9-.3.3-.5.6-.8.9-1.1 1.2-2.2 2.3-3.4 3.4-1.2 1.1-2.4 2.2-3.6 3.2-2.5 2.1-5.1 4-7.8 5.8-1.4.9-2.7 1.7-4.1 2.6-1.4.8-2.8 1.6-4.3 2.3l-.1-.1Z",
    style: {
      fill: "url(#C)"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    "data-name": "startup_plamet_1",
    d: "M1376.5 1332c14.1 0 25.5-11.4 25.5-25.5s-11.4-25.5-25.5-25.5-25.5 11.4-25.5 25.5 11.4 25.5 25.5 25.5Z",
    style: {
      fill: "url(#D)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "startup_big_stars"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 937.9,
    cy: 823.9,
    r: 2.9,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1032.4,
    cy: 850.9,
    r: 2.9,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1392.9,
    cy: 969.9,
    r: 2.9,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 946.9,
    cy: 836.9,
    r: 2.9,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 887.9,
    cy: 1029.9,
    r: 2.9,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 933.9,
    cy: 1142.9,
    r: 2.9,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 845.3,
    cy: 962.2,
    r: 0.8,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1344.2,
    cy: 1199.9,
    r: 2.9,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1325.4,
    cy: 986.6,
    r: 21,
    style: {
      fill: "url(#E)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1055.5,
    cy: 1121.1,
    r: 21,
    style: {
      fill: "url(#F)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "startup_stars"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.76
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 80.6,
    cy: 482.6,
    r: 1.6,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.79
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 146,
    cy: 478,
    r: 1,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.94
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 421.3,
    cy: 475.3,
    r: 1.3,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.71
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 576,
    cy: 492,
    r: 1,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 699.5,
    cy: 486.5,
    r: 1.5,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.74
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 740.8,
    cy: 431.8,
    r: 1.8,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.97
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 993.4,
    cy: 453.4,
    r: 1.4,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.81
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1018.5,
    cy: 500.5,
    r: 1.5,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.77
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1169.2,
    cy: 451.2,
    r: 1.2,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1432.3,
    cy: 479.3,
    r: 1.3,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.72
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.3,
    cy: 582.8,
    r: 1.3,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.84
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 279.4,
    cy: 581.8,
    r: 1.4,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.74
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 328.3,
    cy: 551.7,
    r: 1.3,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 506.7,
    cy: 585.2,
    r: 1.7,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.88
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 643.1,
    cy: 530.6,
    r: 1.1,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.99
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 765.9,
    cy: 548.4,
    r: 0.9,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.84
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 907.5,
    cy: 553.9,
    r: 1.5,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1152.2,
    cy: 582.7,
    r: 1.2,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.99
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1274,
    cy: 582.5,
    r: 1,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.93
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1361.1,
    cy: 574.6,
    r: 1.1,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.72
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 70.9,
    cy: 667.8,
    r: 0.9,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.81
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 161.6,
    cy: 635.6,
    r: 1.7,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.99
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 312.1,
    cy: 662.1,
    r: 1.1,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.85
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 485.3,
    cy: 663.3,
    r: 1.3,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.92
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 625.5,
    cy: 600.4,
    r: 1.5,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.76
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 806.1,
    cy: 617,
    r: 1.1,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 995.1,
    cy: 631,
    r: 1.1,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.75
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1112.8,
    cy: 652.7,
    r: 1.8,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.86
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1281.5,
    cy: 642.5,
    r: 1.5,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.95
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1406.9,
    cy: 632.9,
    r: 0.9,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.96
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36.3,
    cy: 752.7,
    r: 1.3,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.94
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 184,
    cy: 734.4,
    r: 1,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.84
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 323.7,
    cy: 761.1,
    r: 1.7,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.94
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 535.2,
    cy: 761.6,
    r: 1.2,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.95
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 682.4,
    cy: 698.8,
    r: 1.4,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.99
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 761.5,
    cy: 715.9,
    r: 1.5,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.86
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 936,
    cy: 692.5,
    r: 1,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1037.6,
    cy: 696,
    r: 1.6,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.81
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1211.6,
    cy: 698.9,
    r: 1.5,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.88
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1298,
    cy: 685.4,
    r: 1,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.82
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 98.5,
    cy: 784.4,
    r: 1.5,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.88
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 213.2,
    cy: 837.1,
    r: 1.2,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.71
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 312.4,
    cy: 769.2,
    r: 1.4,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.79
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 570.5,
    cy: 840.4,
    r: 1.5,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.74
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 576.9,
    cy: 773.8,
    r: 0.9,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.93
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 837,
    cy: 794.9,
    r: 1,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.76
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 872.6,
    cy: 800.5,
    r: 1.6,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.77
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1145.6,
    cy: 817.5,
    r: 1.6,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.98
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1264.8,
    cy: 772.7,
    r: 1.8,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.85
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1313.2,
    cy: 780.1,
    r: 1.2,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.82
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 98.9,
    cy: 932.3,
    r: 0.9,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.78
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 246.3,
    cy: 857.6,
    r: 1.3,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 392.4,
    cy: 915.8,
    r: 1.4,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.75
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 510.7,
    cy: 873,
    r: 1.7,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.87
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 702.5,
    cy: 876.8,
    r: 1.5,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.75
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 838.4,
    cy: 929.8,
    r: 1.4,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.96
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 959,
    cy: 929.3,
    r: 1,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.72
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1043.1,
    cy: 918.4,
    r: 1.1,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1159.1,
    cy: 924.5,
    r: 1.1,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.91
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1432.2,
    cy: 895.5,
    r: 1.2,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.95
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 121.9,
    cy: 945.7,
    r: 0.9,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 184.2,
    cy: 986,
    r: 1.2,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.86
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 395.4,
    cy: 1000.2,
    r: 1.3,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.73
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 453.5,
    cy: 976.3,
    r: 1.5,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.95
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 618.4,
    cy: 967.2,
    r: 1.4,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.93
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 846,
    cy: 994.8,
    r: 1,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.96
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 951.2,
    cy: 1006,
    r: 1.2,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.95
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1022,
    cy: 965.8,
    r: 1,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.92
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1191.5,
    cy: 999.3,
    r: 1.5,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.89
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1318.9,
    cy: 956.7,
    r: 0.9,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.72
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 45.3,
    cy: 1101.6,
    r: 1.3,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.81
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 170.2,
    cy: 1041.5,
    r: 1.2,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.91
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 430.3,
    cy: 1110.6,
    r: 1.3,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 496.2,
    cy: 1044.4,
    r: 1.2,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.74
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 680.3,
    cy: 1062.6,
    r: 1.3,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 753.1,
    cy: 1104.4,
    r: 1.1,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.84
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 962.5,
    cy: 1101.8,
    r: 1.5,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.79
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1062,
    cy: 1062.3,
    r: 1,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1166.1,
    cy: 1064.4,
    r: 1.1,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.89
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1357.2,
    cy: 1084.5,
    r: 1.2,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.78
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 81.3,
    cy: 1147.1,
    r: 1.3,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 227.8,
    cy: 1175.5,
    r: 1.8,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.84
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 386.2,
    cy: 1120.9,
    r: 1.2,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 567.3,
    cy: 1117,
    r: 1.3,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.93
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 679,
    cy: 1132.8,
    r: 1,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 790.4,
    cy: 1123.1,
    r: 1.4,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.86
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1005,
    cy: 1127.8,
    r: 1,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1126,
    cy: 1159.7,
    r: 1,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.81
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1169.3,
    cy: 1127,
    r: 1.3,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1352.5,
    cy: 1116.2,
    r: 1.5,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.73
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 102.6,
    cy: 1266.8,
    r: 1.6,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.75
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 225.1,
    cy: 1251.3,
    r: 1.1,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.74
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 418.4,
    cy: 1206.6,
    r: 1.4,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.82
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 514,
    cy: 1283.2,
    r: 1,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.92
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 596.3,
    cy: 1220.5,
    r: 1.3,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.76
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 830.1,
    cy: 1245.3,
    r: 1.1,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.88
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 977.4,
    cy: 1208.6,
    r: 1.4,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.94
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1013.5,
    cy: 1257.7,
    r: 1.5,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.75
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1171.2,
    cy: 1200.4,
    r: 1.2,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.89
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1356.2,
    cy: 1275.4,
    r: 1.2,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.99
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26.1,
    cy: 1291.8,
    r: 1.1,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.98
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 199.4,
    cy: 1319.1,
    r: 1.4,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.87
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 391.4,
    cy: 1310,
    r: 1.4,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.98
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 563.2,
    cy: 1332.8,
    r: 1.2,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 623,
    cy: 1348.6,
    r: 1,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.91
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 817.2,
    cy: 1359.9,
    r: 1.2,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.76
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 874.3,
    cy: 1358,
    r: 1.3,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.99
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1113.8,
    cy: 1319.5,
    r: 1.8,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.72
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1195.4,
    cy: 1353,
    r: 1.4,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.77
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1355.2,
    cy: 1299.9,
    r: 1.2,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.93
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 94.3,
    cy: 1454.4,
    r: 1.3,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.98
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 211.5,
    cy: 1420.6,
    r: 1.5,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.72
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 295.6,
    cy: 1406.7,
    r: 1.6,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.76
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 517.9,
    cy: 1455.1,
    r: 0.9,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.78
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 698.5,
    cy: 1376.7,
    r: 1.5,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.86
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 838,
    cy: 1428.2,
    r: 1,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.87
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 913.7,
    cy: 1455.9,
    r: 1.7,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1046.4,
    cy: 1380.5,
    r: 1.4,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.83
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1227.2,
    cy: 1391.3,
    r: 1.2,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.85
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1399.5,
    cy: 1372.6,
    r: 1.5,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.89
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.1,
    cy: 1483.7,
    r: 1.1,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 269.2,
    cy: 1471.8,
    r: 1.2,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.79
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 328.4,
    cy: 1515,
    r: 1.4,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.79
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 561.7,
    cy: 1484.2,
    r: 1.7,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.77
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 695.5,
    cy: 1490.1,
    r: 1.5,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.93
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 749.3,
    cy: 1519.9,
    r: 1.3,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.89
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 875.3,
    cy: 1464.9,
    r: 1.3,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.72
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1108.3,
    cy: 1488.9,
    r: 1.3,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.74
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1215.7,
    cy: 1534.2,
    r: 1.7,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.91
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1414.1,
    cy: 1497.7,
    r: 1.1,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.93
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 110.3,
    cy: 1600.4,
    r: 1.3,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.86
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 193.7,
    cy: 1600.8,
    r: 1.7,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.72
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 350,
    cy: 1599.1,
    r: 1,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.88
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 442.2,
    cy: 1553.2,
    r: 1.2,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.76
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 594.3,
    cy: 1578.4,
    r: 1.3,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.94
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 826,
    cy: 1616,
    r: 1,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.73
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 963,
    cy: 1592,
    r: 1,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.95
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1064.1,
    cy: 1546.2,
    r: 1.1,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.95
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1251.3,
    cy: 1554.3,
    r: 1.3,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.89
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1348.1,
    cy: 1599.1,
    r: 1.1,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.98
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 1703.5,
    r: 1,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.84
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 264.1,
    cy: 1682.6,
    r: 1.1,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.85
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 381.6,
    cy: 1661.1,
    r: 1.6,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 525.4,
    cy: 1690,
    r: 1.4,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 668.8,
    cy: 1633.3,
    r: 1.8,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.79
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 811.6,
    cy: 1716.1,
    r: 1.6,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.77
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 870.9,
    cy: 1690.4,
    r: 0.9,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.76
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1110.7,
    cy: 1650.3,
    r: 1.7,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1158.3,
    cy: 1685.8,
    r: 1.3,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.92
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1372.7,
    cy: 1639.3,
    r: 1.7,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartupBg);
export default __webpack_public_path__ + "static/media/startup_bg.bd7491c00e93dee2ed27d92c5f853384.svg";
export { ForwardRef as ReactComponent };